var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEventsCuate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.11,326.06c-7.69.14-18.89.44-26.48.44h-.44v-.44l-.05-11.19v-.51h.5c7.93,0,18.94.07,26.76.23,0,3.39-.22,8-.28,11.46Zm0,0c-.1-3.28-.2-8-.27-11.19l.27.27c-7.66.14-18.71.2-26.48.22l.5-.49-.06,11.19-.44-.45c7.49,0,18.89.29,26.48.45Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.34,340.17c-7.69.14-18.89.44-26.48.44h-.45v-.44l0-11.19v-.51h.5c7.92,0,18.94.07,26.75.23,0,3.39-.21,8-.27,11.46Zm0,0c-.1-3.28-.21-8-.27-11.19l.27.27c-7.66.14-18.71.2-26.48.22l.5-.49-.06,11.19-.44-.45c7.48,0,18.89.29,26.48.45Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.89,181.84c-7.68.14-18.89.44-26.48.44H426v-.44l-.06-11.19v-.51h.5c7.93,0,18.95.07,26.76.23,0,3.39-.22,8-.28,11.46Zm0,0c-.09-3.28-.2-8-.27-11.19l.27.27c-7.65.14-18.71.2-26.48.23l.5-.5-.05,11.19-.45-.45c7.49,0,18.9.29,26.48.45Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.12,196c-7.69.14-18.89.44-26.48.44h-.44V196l-.06-11.19v-.51h.5c7.93,0,18.94.07,26.76.23,0,3.39-.22,8-.28,11.46Zm0,0c-.1-3.28-.2-8-.27-11.19l.27.27c-7.65.14-18.71.2-26.48.23l.5-.5L412.09,196l-.45-.45c7.49,0,18.89.29,26.48.45Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.41,181.84c-7.69.14-18.89.44-26.48.44h-.44v-.44l-.05-11.19v-.51h.5c7.92,0,18.94.07,26.75.23,0,3.39-.21,8-.27,11.46Zm0,0c-.1-3.28-.2-8-.27-11.19l.27.27c-7.66.14-18.71.2-26.48.23l.5-.5-.06,11.19-.44-.45c7.49,0,18.89.29,26.48.45Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.14,340.17c-7.69.14-18.89.44-26.48.44h-.44v-.44L670.16,329v-.51h.5c7.93,0,18.94.07,26.76.23,0,3.39-.22,8-.28,11.46Zm0,0c-.1-3.28-.2-8-.27-11.19l.27.27c-7.65.14-18.71.2-26.48.22l.5-.49,0,11.19-.45-.45c7.49,0,18.89.29,26.48.45Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.37,66.49c-7.69.14-18.89.44-26.48.44h-.44v-.45l-.05-11.19v-.51h.5c7.93,0,18.94.07,26.76.23,0,3.39-.22,8-.28,11.46Zm0,0c-.1-3.28-.2-8-.27-11.19l.27.27c-7.66.14-18.71.21-26.48.23l.5-.5,0,11.19-.45-.45c7.49,0,18.89.29,26.48.45Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.14,80.6c-7.69.14-18.89.44-26.48.44h-.44V80.6l-.06-11.19V68.9h.5c7.93,0,18.94.07,26.76.23,0,3.39-.22,8-.28,11.46Zm0,0c-.1-3.28-.2-8-.27-11.19l.27.27c-7.65.14-18.71.21-26.48.23l.5-.5,0,11.19-.45-.45c7.49,0,18.89.29,26.48.45Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.11,66.49c-7.69.14-18.89.44-26.48.44h-.44v-.45L67.13,55.3v-.51h.5c7.93,0,18.94.07,26.76.23,0,3.39-.22,8-.28,11.46Zm0,0c-.1-3.28-.2-8-.27-11.19l.27.27c-7.66.14-18.71.21-26.48.23l.5-.5-.06,11.19L67.63,66c7.49,0,18.89.29,26.48.45Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64.22 423.44 251.12 423.44 255 346.75 60.33 346.75 64.22 423.44",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.26,381.85H164.12l-1.46-26.62H244ZM165,380.91h76.36L243,356.17H163.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.82,412.48H167.18l-1.19-24h76.33Zm-72.74-.94h71.85l1.38-22.15H167Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.71,371.43H197.58l-.82-6.42h14.78Zm-12.3-.94h11.47l.59-4.54H197.83Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.71,403.68H197.58l-.82-6.42h14.78Zm-12.3-.95h11.47l.59-4.53H197.83Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.35,381.85H72.21l-1.46-26.62h81.31Zm-77.24-.94h76.36l1.58-24.74H71.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.91,412.48H75.27l-1.19-24h76.33Zm-72.74-.94H148l1.39-22.15H75.07Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.81,371.43H105.68l-.83-6.42h14.78Zm-12.31-.94H118l.58-4.54H105.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.81,403.68H105.68l-.83-6.42h14.78Zm-12.31-.95H118l.58-4.53H105.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.98 423.44 79.81 431.79 77.44 448.58 72.83 448.58 72.83 423.44 80.98 423.44",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.98 423.44 79.81 431.79 72.83 431.79 72.83 423.44 80.98 423.44",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.35 423.44 235.53 431.79 237.89 448.58 242.5 448.58 242.5 423.44 234.35 423.44",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.35 423.44 235.53 431.79 242.5 431.79 242.5 423.44 234.35 423.44",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 641.06,
    y: 85.43,
    width: 56.6,
    height: 68.65,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.52,
    y: 91.7,
    width: 43.66,
    height: 56.12,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.52,
    y: 91.7,
    width: 1.7,
    height: 56.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 697.65,
    y: 85.43,
    width: 1.7,
    height: 68.65,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 662.15,
    y: 99.43,
    width: 10.3,
    height: 30.67,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.62,135.85H657.16v-16h28.46Zm-27.46-1h26.46v-14H658.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 612.76,
    y: 178.52,
    width: 56.6,
    height: 68.65,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619.22,
    y: 184.78,
    width: 43.66,
    height: 56.12,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619.22,
    y: 184.78,
    width: 1.7,
    height: 56.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 669.35,
    y: 178.52,
    width: 1.7,
    height: 68.65,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636.83,
    y: 199.29,
    width: 8.82,
    height: 22.3,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.43,228.71H630.74V212.34h24.69Zm-23.69-1h22.69V213.34H631.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.16,
    cy: 91.7,
    r: 44.02,
    transform: "translate(-7.31 173.38) rotate(-72.23)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.18,
    cy: 92.68,
    r: 42,
    transform: "translate(-27.57 55.69) rotate(-24.01)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.18,
    cy: 92.68,
    r: 39.35,
    transform: "matrix(0.99, -0.17, 0.17, 0.99, -14.1, 21.36)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.63,84.33C137.72,95.18,108.27,113,91.8,122.76A39.51,39.51,0,0,1,81.05,108.3l54.44-50.46A39.38,39.38,0,0,1,155.63,84.33Z",
    style: {
      fill: "#ebebeb",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.5,94.05a39.06,39.06,0,0,1-2.6,12.79l-49.08,23.21a39.68,39.68,0,0,1-6.2-2.67C113.45,118.82,140.54,103.23,156.5,94.05Z",
    style: {
      fill: "#ebebeb",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.8,
    y: 56.18,
    width: 0.76,
    height: 5.96,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.04,
    y: 60.67,
    width: 0.76,
    height: 5.96,
    transform: "translate(-18.37 58.73) rotate(-30)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.77,
    y: 72.94,
    width: 0.76,
    height: 5.96,
    transform: "translate(-21.68 114.3) rotate(-60)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.68,
    y: 92.3,
    width: 5.96,
    height: 0.76,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.17,
    y: 109.05,
    width: 5.96,
    height: 0.76,
    transform: "translate(-42.91 58.74) rotate(-30)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.44,
    y: 121.32,
    width: 5.96,
    height: 0.76,
    transform: "translate(-55.17 147.92) rotate(-60.04)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.8,
    y: 123.21,
    width: 0.76,
    height: 5.96,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.55,
    y: 118.72,
    width: 0.76,
    height: 5.96,
    transform: "translate(-42.91 83.27) rotate(-30)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.82,
    y: 106.45,
    width: 0.76,
    height: 5.96,
    transform: "translate(-21.68 181.32) rotate(-60)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.7,
    y: 92.3,
    width: 5.96,
    height: 0.76,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.22,
    y: 75.54,
    width: 5.96,
    height: 0.76,
    transform: "translate(-18.37 83.28) rotate(-30)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.95,
    y: 63.28,
    width: 5.96,
    height: 0.76,
    transform: "translate(11.88 147.87) rotate(-60.03)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.75 58.89 119.04 95.33 115.31 95.29 116.73 58.87 117.75 58.89",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.45 79.97 115.93 95.62 114.15 92.34 139.97 79.08 140.45 79.97",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.45,92.68a1.28,1.28,0,1,1-1.27-1.28A1.27,1.27,0,0,1,118.45,92.68Z",
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Calendar--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 140.62,
    y: 95.69,
    width: 468.77,
    height: 352.89,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.88,
    y: 95.69,
    width: 24.73,
    height: 352.89,
    transform: "translate(256.5 544.27) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.62,
    y: 95.69,
    width: 468.77,
    height: 38.07,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.6,
    y: 171.65,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.6,
    y: 171.65,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.3,
    y: 171.65,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.06,
    y: 171.65,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.78,
    y: 171.65,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.51,
    y: 171.65,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 459.23,
    y: 171.65,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.96,
    y: 171.65,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.6,
    y: 224.17,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.6,
    y: 224.17,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.33,
    y: 224.17,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.05,
    y: 224.17,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.78,
    y: 224.17,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.51,
    y: 224.17,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 459.24,
    y: 224.17,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.96,
    y: 224.17,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.6,
    y: 276.69,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.6,
    y: 276.69,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.33,
    y: 276.69,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.06,
    y: 276.69,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.78,
    y: 276.69,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.51,
    y: 276.69,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 459.23,
    y: 276.69,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.96,
    y: 276.69,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.6,
    y: 329.21,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.6,
    y: 329.21,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.33,
    y: 329.21,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.05,
    y: 329.21,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.78,
    y: 329.21,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.51,
    y: 329.21,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 459.24,
    y: 329.21,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.96,
    y: 329.21,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.6,
    y: 381.73,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.6,
    y: 381.73,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.33,
    y: 381.74,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.05,
    y: 381.73,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.78,
    y: 381.73,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.51,
    y: 381.73,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 459.23,
    y: 381.73,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.96,
    y: 381.73,
    width: 46.44,
    height: 46.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.31,160.08a2.07,2.07,0,0,0-.79-.53,2.75,2.75,0,0,0-1.11-.21,2.09,2.09,0,0,0-1.34.35,1.16,1.16,0,0,0-.42.94,1,1,0,0,0,.11.52,1,1,0,0,0,.35.35,2.46,2.46,0,0,0,.6.25l.86.22a7.39,7.39,0,0,1,1,.26,2.83,2.83,0,0,1,.76.37,1.43,1.43,0,0,1,.48.53,1.67,1.67,0,0,1,.16.78,1.86,1.86,0,0,1-.18.84,1.7,1.7,0,0,1-.52.58,2.19,2.19,0,0,1-.79.35,4.06,4.06,0,0,1-1,.11,4.14,4.14,0,0,1-2.79-1l.34-.56a2.77,2.77,0,0,0,.44.37,3.34,3.34,0,0,0,1.26.51,3.79,3.79,0,0,0,.77.08,2.37,2.37,0,0,0,1.29-.3,1,1,0,0,0,.47-.91,1.13,1.13,0,0,0-.13-.54,1,1,0,0,0-.4-.38,2.73,2.73,0,0,0-.66-.28c-.26-.08-.56-.16-.91-.24s-.68-.17-1-.26a2.77,2.77,0,0,1-.69-.34,1.46,1.46,0,0,1-.43-.5,1.66,1.66,0,0,1-.14-.71,2,2,0,0,1,.18-.86,1.56,1.56,0,0,1,.52-.62,2.18,2.18,0,0,1,.78-.38,3.71,3.71,0,0,1,2.24.07,3.19,3.19,0,0,1,1,.6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,165.17a2.25,2.25,0,0,0,1.09-.25,2,2,0,0,0,.69-.66,2.58,2.58,0,0,0,.37-.92,6.22,6.22,0,0,0,.1-1.05v-3.51h.68v3.51a5.71,5.71,0,0,1-.15,1.33,3.11,3.11,0,0,1-.51,1.12,2.47,2.47,0,0,1-.9.76,3.41,3.41,0,0,1-2.75,0,2.44,2.44,0,0,1-.9-.78,3.06,3.06,0,0,1-.49-1.12,5.55,5.55,0,0,1-.15-1.29v-3.51h.67v3.51a5.47,5.47,0,0,0,.11,1.07,2.78,2.78,0,0,0,.37.92,1.93,1.93,0,0,0,.69.64A2.11,2.11,0,0,0,213,165.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.27,160.06v5.67h-.69v-6.95h.53l4.6,5.79v-5.78h.69v6.94h-.6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.83,165.73V160l-2.54,4.41h-.4L257.35,160v5.7h-.68v-6.95h.7l2.72,4.76,2.73-4.76h.69v6.95Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.06,165.78a2.92,2.92,0,0,1-1.33-.3,3.08,3.08,0,0,1-1-.79,3.56,3.56,0,0,1-.67-1.13,3.65,3.65,0,0,1-.24-1.3,3.74,3.74,0,0,1,.25-1.33,3.81,3.81,0,0,1,.69-1.13,3.47,3.47,0,0,1,1-.78,3,3,0,0,1,1.29-.29,2.93,2.93,0,0,1,1.33.31,3.43,3.43,0,0,1,1,.81,3.86,3.86,0,0,1,.66,1.13,3.6,3.6,0,0,1,.24,1.29,3.66,3.66,0,0,1-.94,2.45,3.46,3.46,0,0,1-1,.78A3,3,0,0,1,268.06,165.78Zm-2.58-3.52a3.09,3.09,0,0,0,.19,1.09,2.85,2.85,0,0,0,.53.93,2.45,2.45,0,0,0,.81.65,2.26,2.26,0,0,0,1.05.24,2.22,2.22,0,0,0,1.06-.26,2.77,2.77,0,0,0,.82-.66,3.22,3.22,0,0,0,.69-2,3.09,3.09,0,0,0-.19-1.09,3.26,3.26,0,0,0-.53-.93,2.56,2.56,0,0,0-.82-.64,2.37,2.37,0,0,0-2.1,0,2.61,2.61,0,0,0-.81.66,3,3,0,0,0-.52.93A3.23,3.23,0,0,0,265.48,162.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.3,160.06v5.67h-.69v-6.95h.53l4.6,5.79v-5.78h.69v6.94h-.6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.42,159.39h-2.48v6.34h-.69v-6.34h-2.47v-.61h5.64Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.27,165.17a2.29,2.29,0,0,0,1.1-.25,2,2,0,0,0,.69-.66,2.76,2.76,0,0,0,.36-.92,5.35,5.35,0,0,0,.11-1.05v-3.51h.68v3.51a5.21,5.21,0,0,1-.16,1.33,3.09,3.09,0,0,1-.5,1.12,2.43,2.43,0,0,1-.91.76,2.94,2.94,0,0,1-1.36.28,2.87,2.87,0,0,1-1.38-.3,2.48,2.48,0,0,1-.91-.78,3.24,3.24,0,0,1-.49-1.12,5.54,5.54,0,0,1-.14-1.29v-3.51H319v3.51a5.47,5.47,0,0,0,.11,1.07,2.58,2.58,0,0,0,.37.92,1.93,1.93,0,0,0,.69.64A2,2,0,0,0,321.27,165.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.52,165.13v.6h-4.67v-6.95h4.58v.61h-3.9v2.51h3.4v.57h-3.4v2.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.88,158.83h.65l1,2.47,1-2.47h.65l-1.21,3,1.33,3.14,2.52-6.16h.74l-2.94,6.95H370l-1.46-3.43-1.47,3.43h-.6l-2.93-6.95h.73l2.53,6.16,1.32-3.14Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.18,165.13v.6h-4.67v-6.95h4.58v.61H375.2v2.51h3.4v.57h-3.4v2.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.48,165.73v-6.95h2.35a3.49,3.49,0,0,1,1.46.28,3,3,0,0,1,1,.74,3.21,3.21,0,0,1,.62,1.1,4.24,4.24,0,0,1,.21,1.35,4,4,0,0,1-.23,1.43,3.13,3.13,0,0,1-.67,1.1,2.93,2.93,0,0,1-1.05.7,3.57,3.57,0,0,1-1.38.25Zm5-3.48a3.51,3.51,0,0,0-.18-1.15,2.79,2.79,0,0,0-.51-.91,2.37,2.37,0,0,0-.83-.59,2.85,2.85,0,0,0-1.13-.21h-1.67v5.74h1.67a2.91,2.91,0,0,0,1.15-.22,2.29,2.29,0,0,0,.82-.61,2.62,2.62,0,0,0,.51-.91A3.78,3.78,0,0,0,385.48,162.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.24,159.39h-2.48v6.34h-.69v-6.34H418.6v-.61h5.64Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.76,158.78v6.95h-.68v-3.25H426v3.25h-.69v-6.95H426v3.1h4.12v-3.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.32,165.17a2.22,2.22,0,0,0,1.09-.25,2,2,0,0,0,.7-.66,2.76,2.76,0,0,0,.36-.92,5.33,5.33,0,0,0,.1-1.05v-3.51h.69v3.51a5.21,5.21,0,0,1-.16,1.33,3.09,3.09,0,0,1-.5,1.12,2.51,2.51,0,0,1-.91.76,2.94,2.94,0,0,1-1.36.28,2.87,2.87,0,0,1-1.38-.3,2.48,2.48,0,0,1-.91-.78,3.24,3.24,0,0,1-.49-1.12,5.55,5.55,0,0,1-.15-1.29v-3.51h.68v3.51a4.8,4.8,0,0,0,.11,1.07,2.76,2.76,0,0,0,.36.92,2,2,0,0,0,1.77.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476,165.73v-6.95h4.56v.61h-3.87V162H480v.56h-3.27v3.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.8,165.73v-6.95h2.94a1.87,1.87,0,0,1,.82.19,2.3,2.3,0,0,1,.65.5,2.25,2.25,0,0,1,.58,1.5,2.58,2.58,0,0,1-.11.73,2.4,2.4,0,0,1-.31.62,1.82,1.82,0,0,1-.49.47,1.58,1.58,0,0,1-.64.26l1.71,2.68h-.78l-1.63-2.56h-2.06v2.56Zm.68-3.17h2.27a1.16,1.16,0,0,0,.56-.13,1.32,1.32,0,0,0,.42-.36,1.8,1.8,0,0,0,.28-.51,1.92,1.92,0,0,0,.1-.59,1.62,1.62,0,0,0-.12-.61,1.51,1.51,0,0,0-.75-.84,1.16,1.16,0,0,0-.54-.13h-2.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.19,165.73v-6.95h.69v6.95Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.39,160.08a2.07,2.07,0,0,0-.79-.53,2.78,2.78,0,0,0-1.11-.21,2.14,2.14,0,0,0-1.35.35,1.16,1.16,0,0,0-.42.94,1,1,0,0,0,.46.87,2.74,2.74,0,0,0,.61.25l.86.22a7.79,7.79,0,0,1,1,.26,2.76,2.76,0,0,1,.75.37,1.55,1.55,0,0,1,.49.53,1.67,1.67,0,0,1,.16.78,1.86,1.86,0,0,1-.18.84,1.7,1.7,0,0,1-.52.58,2.24,2.24,0,0,1-.8.35,3.93,3.93,0,0,1-1,.11,4.18,4.18,0,0,1-2.8-1l.35-.56a2.77,2.77,0,0,0,.44.37,3.34,3.34,0,0,0,1.26.51,3.77,3.77,0,0,0,.76.08,2.38,2.38,0,0,0,1.3-.3,1,1,0,0,0,.47-.91,1,1,0,0,0-.14-.54,1,1,0,0,0-.39-.38,2.91,2.91,0,0,0-.66-.28c-.26-.08-.56-.16-.91-.24s-.68-.17-1-.26a2.77,2.77,0,0,1-.69-.34,1.46,1.46,0,0,1-.43-.5,1.66,1.66,0,0,1-.14-.71,2,2,0,0,1,.18-.86,1.62,1.62,0,0,1,.51-.62,2.32,2.32,0,0,1,.79-.38,3.45,3.45,0,0,1,1-.14,3.37,3.37,0,0,1,1.23.21,3.13,3.13,0,0,1,1,.6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.3,158.78h.58l2.89,6.95H539l-.9-2.17H535l-.89,2.17h-.74ZM538,163l-1.4-3.43L535.17,163Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545,159.39h-2.48v6.34h-.68v-6.34h-2.48v-.61H545Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.6,
    y: 180.84,
    width: 29.85,
    height: 2.32,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.6,
    y: 185.93,
    width: 16.89,
    height: 2.32,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.87,
    y: 390.81,
    width: 29.85,
    height: 2.32,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.87,
    y: 395.89,
    width: 16.89,
    height: 2.32,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413.09,
    y: 337.36,
    width: 29.85,
    height: 2.32,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413.09,
    y: 347.54,
    width: 15.63,
    height: 2.32,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413.09,
    y: 342.45,
    width: 21.52,
    height: 2.32,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.11,
    y: 295.55,
    width: 15.63,
    height: 2.32,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.11,
    y: 290.47,
    width: 21.52,
    height: 2.32,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.78,288.06l-.12-.25C342.91,288.34,342.77,288.05,342.78,288.06Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.72 293.48 344.69 293.38 344.89 294.21 344.72 293.48",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.27,298.82a16.2,16.2,0,0,0-.12-2.9v-.16a3.1,3.1,0,0,0-.08-.42A19.25,19.25,0,0,1,345.27,298.82Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.87,301.65c.05-.17-.08.61.12-.65l0,.12C344.94,301.23,344.92,301.39,344.87,301.65Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,301.12c.1-.56-.07.36,0,0Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.38,303.64a5.71,5.71,0,0,0,.19-.71,3.14,3.14,0,0,1-.18.54C344.17,304.19,344.23,304.05,344.38,303.64Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.21,304.32l.11-.36A1.75,1.75,0,0,0,344.21,304.32Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.55,303.18l-.23.78a1.07,1.07,0,0,0,.1-.36C344.42,303.67,344.45,303.51,344.55,303.18Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.67,302.73c.1-.4.24-.92.08-.19a5.21,5.21,0,0,0,.18-1C344.92,301.64,344.84,302,344.67,302.73Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.31,299.1l0-.56v-.48C345.33,298.3,345.29,299.14,345.31,299.1Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.4,307.77c0,.05.16-.19.21-.23l.26-.47C342.72,307.3,342.44,307.75,342.4,307.77Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.61,307.54a6.33,6.33,0,0,1-.44.7C342.61,307.65,342.63,307.51,342.61,307.54Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.22,304.47l.38-1.3c-.16.51-.28,1-.47,1.54Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.46 310.19 340.75 309.83 340.22 310.46 340.46 310.19",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,311.6c.23-.25-.39.26-.14,0l-1.12.94C338.06,312.26,338.47,312,339,311.6Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.14,313a6.76,6.76,0,0,0,.57-.44C337.53,312.71,337.33,312.84,337.14,313Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.33,309.34a3.54,3.54,0,0,0-.45.46l.24-.21Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.13,309.58h0a4.88,4.88,0,0,1-.46.51A5.46,5.46,0,0,0,341.13,309.58Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.38,309.28l-.05.06Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.32,306.42c-.18.45-.7,1.31-.17.5C343.3,306.6,343,307.09,343.32,306.42Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.68,309c.18-.22.34-.46.52-.7,0,0-.13.13,0-.07C342,308.49,341.86,308.75,341.68,309Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.42 309.34 341.68 309 341.47 309.25 341.42 309.34",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.37,312.17c-.29.23-.6.5-1,.76.43-.26.82-.59,1.22-.88C338.64,312,338.79,311.84,338.37,312.17Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.79,311l-.06.06Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.39 315.12 333.46 315.1 333.47 315.08 333.39 315.12",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.67,312a4.41,4.41,0,0,0,.6-.54,8,8,0,0,1-.67.58S338.58,312.08,338.67,312Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.08,313.69a4.53,4.53,0,0,0,.56-.31Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.62,311.12l0,0C339.56,311.15,339.58,311.15,339.62,311.12Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.62,311.12l-.35.35.46-.42Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.25,316a11.14,11.14,0,0,1,1.74-.8c.75-.4.17-.32-.53-.1,0,0,0,0-.79.4.3-.05,1.78-.69,1.14-.35a6.32,6.32,0,0,1-1.4.54c.24-.06-.09.1-.45.28s-.75.32-.61.34c.32-.12.63-.24.94-.39C332.31,315.93,332,316.09,332.25,316Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.94,314.4l.31-.18a7.37,7.37,0,0,1-1.13.48,4.22,4.22,0,0,0-.65.38c.52-.25,1.06-.48,1.57-.74Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.62,313.43c-.19.22-.93.64-.44.44a9.44,9.44,0,0,0,1.1-.79c-1.4.93.38-.28-.65.35l.75-.5-.74.45,0,0h0l0,0s0,0-.05.06c-.41.26-.07,0,.05-.06h0c-.45.33-1,.57-1.43.86C335.55,314.05,336,313.86,336.62,313.43Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.77,307.74l0,0C342.68,307.88,342.67,307.92,342.77,307.74Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.37,308.31c.06-.11.13-.22.33-.53s0,0,0,0c.11-.21.4-.74,0-.1l-.06.1a11.58,11.58,0,0,1-.87,1.14A6.87,6.87,0,0,0,342.37,308.31Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.73,311.22c-.35.31-.67.65-1,.94a6.07,6.07,0,0,0,.57-.43h0C339.82,311.21,339.67,311.31,339.73,311.22Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.23 315.15 333.37 315.02 332.66 315.4 333.23 315.15",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.54 315.81 331.58 315.74 331.14 315.92 331.54 315.81",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.39,288l.28.33Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.41,285.56h-.09C339.44,285.63,339.49,285.66,339.41,285.56Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.82,301.18c.1-.59.24-1.23.13-1.16l-.1.17A7.32,7.32,0,0,1,296.82,301.18Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.94,280.84h-.18l-.38.19Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.26,280.29l.81-.09Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.83,304.15l-.09.52C344,303.92,343.86,304.23,343.83,304.15Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.18,317.85c-.51-.07-.9-.2-1.25-.26A3.44,3.44,0,0,0,313.18,317.85Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.74,287.72c.17.17.26.24.27.22C339.83,287.76,339.72,287.66,339.74,287.72Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.49,317.28l.26.1c.36.06.74.11,1.18.21A11.76,11.76,0,0,0,310.49,317.28Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.08,299.47v-.13A.41.41,0,0,0,298.08,299.47Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.38,285.57l-.61.36Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.44,317.49c.38-.07.06,0,0,0Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.34,317.46c-.08,0-.14,0-.14.06A.48.48,0,0,1,326.34,317.46Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.7,316.55l0,0Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,317.43l-.49.06Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.93,317.41l.34-.05S325.27,317.34,324.93,317.41Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.91,317.57l.62-.08h-.09Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.16,316.77h-.08C319.69,316.84,319.86,316.82,320.16,316.77Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.41,291.29l0,0,0-.05Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.13,290a5.42,5.42,0,0,1-.7,1.24l.52-.23C299,290.72,299,290.36,299.13,290Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.41,294.7l-.15-1c.49,1.15.53,2.07.51,1.08a8,8,0,0,1-.72-1.95c-.3-1-.75-1.85-.92-1.85-.06-.22-.15-.42-.23-.63l.2.36c-.44-1.24-.63-.76-1.46-2.2-.32-.49-.51-.85-.25-.55a10,10,0,0,0-.85-1c-.24-.3-.13-.27.1,0l-.64-.76-.7-.7h0c-.23-.18-.76-.55-1-.72-.34-.37.21.14.15,0-.3-.21-.58-.45-.89-.64-.29-.35.48.13,1,.66-.55-.93-.7-.58-2.41-2a7.34,7.34,0,0,1,.89.55,3.27,3.27,0,0,0-.86-.77c-.36-.26-.77-.54-1.28-.87.25.16,1.87,1.5.81.93a4.89,4.89,0,0,0-1.25-.67c.06-.11-.5-.4-1.23-.69l.11-.13a4.23,4.23,0,0,0-1.26-.29,2.7,2.7,0,0,1-1.22-.69c-1.46-.42,1,.47-.78,0a8.5,8.5,0,0,0-1.68-.4,13.94,13.94,0,0,0-1.9-.17c-.86-.16.16-.09-.14-.17l-.78.05c-.19,0-.13-.05-.1-.07-.65,0-.06.16-1.08.16-.27.15-2.1-.32-3.35,0-.31,0,.14-.11.05-.17a14.79,14.79,0,0,0-2.85.61c-.41,0-.81,0-1.21.08.89-.05-.2.31-1.13.64l.77,0-1.51.4c-.19,0-.05-.07.18-.19l-.27.1c-.55.08-.3-.1.07-.28h.58c.36-.18.69-.36.59-.44s-.28.09-.49.15c.09-.05.15-.09.1-.1a3.14,3.14,0,0,0-.46.16l-.39-.11-.07.09-2,.42c-1.37.6-2.51,1.25-4.61,2.26.48-.35,0-.25,0-.41a4.48,4.48,0,0,0,1.21-.48,7.86,7.86,0,0,1,1.61-.67c-.61.18-.51.07-.36,0a19.84,19.84,0,0,0-2,.95c0-.13-.48.06-1,.29.51.06-1.4.85-2.09,1.43-.08,0,0-.27,1-.76-1.16.4-1.17,1.06-2.25,1.54.21-.16.35-.21.41-.31-.49.38-1.7,1.28-1.47,1l.21-.16a10.45,10.45,0,0,0-1.24,1,13.75,13.75,0,0,0-1.28,1.25,5.69,5.69,0,0,0-1.31,1.83,1,1,0,0,1,0-.46,20.43,20.43,0,0,0-1.15,3c0-.32-.94.38-.28-.93a6.62,6.62,0,0,0-.86,1.62c.15-.25.56-.52.39-.17a8.87,8.87,0,0,0-1.08,1.79c.21-.39.25.15.06.78,0-.11-.28,0-.24-.28-.06.58-.16,1.14-.19,1.71,0-.43-.21-.13-.36.23.08-.17-.3,1.44-.28,1.9l.14-.71c-.23,1.91.18,1.91.25,3.76-.08-.22-.39-.54-.34.43.08.21.28.68.57,1.27s.59,1.31.86,2.07c0,.1,0,.21,0,.32l.52,1.12a13.59,13.59,0,0,1-1.89-3.82,5.68,5.68,0,0,0,.14,1.27c0,.4-.22-.55-.27-.87a17.76,17.76,0,0,0,.56,2.48c.1-.16.82,1.75.93,1.6a18.63,18.63,0,0,1-1.06-2.52c.06-.07.27.28.53.85s.63,1.34,1,2.12c.15.42-.39-.18-.42-.13s.28.46.48.82.43.69.45.77c-.15-.2-.32-.39-.46-.6.47.88,1,1.29,1.6,2.3.22.34.64,1.06.76,1.05-.33-.61,0-1,.39-.8l.69.9c.36.43.78.86.92,1.05.41.54-1-.43-.6,0a2.61,2.61,0,0,1,.48.29c.3.3-.24,0,.51.55.22,0,1.51,1.13.43.16.75.51.76.59,1.67,1.13-.12-.12.13-.07.5.07s.9.29,1.3.47c-.06,0,.1.14.18.21.82.38,1.49.61,2.13.88s1.29.42,2.13.6c.15.06,1,.25.59.24a8.07,8.07,0,0,1,1,.11c1,.28-1.16-.18-.42.09.08,0,1.38.08,2.13.1a24,24,0,0,0-2.47-.3c0-.08.35-.11.9-.08s1.32,0,2.2.06c1.4,0,.6.12.85.1a10.73,10.73,0,0,0,2.39-.11,13.33,13.33,0,0,1,2.05-.14c.88,0,.05.19.25.24-1.14.14-1.77,0-2.55.07h1a13,13,0,0,1-1.56.08,53.27,53.27,0,0,0,6.53-.39c.36-.07,1-.22.68-.2l-.64.11c-.6,0,1.19-.28.38-.19.84-.21,1.79-.39,3-.64l.24.05a6,6,0,0,0-1.12.22,17.52,17.52,0,0,0,2.37-.54c-.28.05-.56.11-.85.14l2.87-.93c-.49.06-.22.11-1,.21.68,0-2.66.7-1.59.57-.8,0-1.34.26-2.37.32,0,0,.37,0-.52.13l-.19.06h0s-.05,0,0,0a2.92,2.92,0,0,1,.47,0,21.07,21.07,0,0,1-2.34.45c-.53,0,.22-.06-.07-.06l-.72.14c-.08-.06-1.43,0-.18-.15-.38.05-.76.06-1.13.09-.68,0-1.59.06-2.16.09s-1.35.13-.89.06a17.52,17.52,0,0,1-1.77.05l0,0-1.33,0c-.45,0-.9-.07-1.37-.11a14.3,14.3,0,0,1-2.82-.54,17.4,17.4,0,0,1-2.08-.6l-.16-.14c-.35-.13-.87-.33-1.33-.54a6.05,6.05,0,0,0-1-.48c-.33-.25-1.07-.74-1.89-1.23l-1.16-.85a9.86,9.86,0,0,1-.9-.79l-.11.05a12.26,12.26,0,0,1-1-.95,10.44,10.44,0,0,1-1-1.13l0,.12a14.16,14.16,0,0,1-2-3.48,3.12,3.12,0,0,1,.34.69c-.6-1.71-1.54-3.55-1.58-5.24a5.37,5.37,0,0,1-.08-1l0,.1,0-.17c0-.18,0-.37,0-.57a2,2,0,0,0,0,.48c-.05-.31,0-.8-.06-1.27l.12-.2v-.1c0-.46,0-.38-.15-.14,0-.24,0-.45,0-.63.22-.35.05-1.25.38-1.71-.09-.35.5-2.32.41-2.63,0,0,.1-.13,0,.11a9.27,9.27,0,0,0,.56-1.44l.24-.14.35-1.12c.41-.58.65-.78.37-.14a22.11,22.11,0,0,1,1.38-2.45l0,.12a6.34,6.34,0,0,1,1-1.28c.24-.18.58-.55,1.07-.95a20.78,20.78,0,0,1,1.73-1.4,19.86,19.86,0,0,1,4.32-2.5c-.65,0,1.32-.42,1.34-.67.19,0,.58-.12.16.12a10.88,10.88,0,0,1,1.72-.62,9.88,9.88,0,0,0,1.39-.53c.18,0-.29.18-.13.18a2.57,2.57,0,0,1,.61-.18c.16,0-.19.11-.42.21,1.49-.41,1.59-.67,1.65-.9a4.56,4.56,0,0,0,1.71-.42c.28,0,.74,0-.2.21.53-.15,3.28-.45,3.32-.61a4.37,4.37,0,0,0,.9-.08c1.21-.11,1.32-.07,2.52-.11l-.34,0c.48-.23,1-.07,2,0l0,0c1.1.11,1.33.17,1.57.17a6,6,0,0,1,1.53.27l-.1-.15c.12-.11.6,0,1.19.19a18.26,18.26,0,0,0,1.9.61,3.11,3.11,0,0,0-.41-.2,9.6,9.6,0,0,1,2.3,1.27c.13.08-.23-.06-.42-.13,1.56.87.29-.08,1.5.47.18.19-.38,0,.4.48a12.62,12.62,0,0,1,3.2,2c-.16-.23-.32-.46.18-.09.77.58,1.66,2,2.35,2.49.07.11.08.15.07.17.24.28.61.74.94,1.18a12.37,12.37,0,0,0,.78,1.05,10,10,0,0,0,1,2.33c.42,1,.71,1.89.52,1.93a9.6,9.6,0,0,1,.25,1.09,10.07,10.07,0,0,1,.17,1.1l0-.06c.06.71.11,1.18.14,1.56s.08.6.12.87-.06.09-.08.06a10.23,10.23,0,0,1-.14,1.25c-.05.34-.07.62-.12.87-.08.53-.12,1-.3,1.88l-.17.14a8.36,8.36,0,0,1-.8,1.76,15.17,15.17,0,0,1-.83,1.27,15.81,15.81,0,0,1-.89,1.31s0-.07.11-.2c-1.33,1.94-4.23,3.47-4.73,4.23l-.62.46-.66.4c1.79-.9-.18.29.58,0-.69.39-1.87.83-1,.37l.15-.06c.11-.17-.45.1-1,.39a3.72,3.72,0,0,1-1.25.45A35.74,35.74,0,0,1,320.93,316l.43.11-1.28.1c-.34,0-.46-.08.46-.15a8.75,8.75,0,0,0-1.56.17c-1.8,0,.7-.17.15-.17l-.75,0h.17a7.1,7.1,0,0,1-1.76.11c-.7-.07-.36-.11-.63-.13a1.66,1.66,0,0,0-.42,0c-.53-.05-1.08,0-1.61-.14.21.06.42.13.63.17-.72,0-1.5-.21-.78,0-.53-.18-2-.36-3.44-.74a12.42,12.42,0,0,1-1.93-.57l-1.11-.39a11.94,11.94,0,0,1-2.84-1.48c.24.19.34.38-.53-.23.11,0,.07-.06-.06-.17a4.71,4.71,0,0,1-.57-.52,9.23,9.23,0,0,1-1.25-1.36c.39.66-1.84-2.35-1.22-1.33-.44-.77,0-.08-.27-.68a14.7,14.7,0,0,1-2.17-6.8s0,.4-.09-.15l0-.69.07-.68a7.89,7.89,0,0,1,0-1.41c0,.13-.05.33,0,0a17.89,17.89,0,0,1,2.52-7.28l1.11-1.62,1.35-1.44a9.57,9.57,0,0,1,1.47-1.3,16,16,0,0,1,1.57-1.17c-.62.35-.21.11.25-.17-.3.18,0,0-.06,0l1.88-1.11c.33-.23,2.14-.95,2.34-1.06l-.63.28c.84-.37-1.2.49-1.08.42a14.52,14.52,0,0,0-1.73.92,10.9,10.9,0,0,0-2.06,1.33c-.3.22.25-.21.08-.09-.33.28-.74.6-1.5,1.18l.08-.07a18.16,18.16,0,0,0-4.25,5.42L300,293l-.53,1c-.29.69.85-1.65.59-1-.64.67-1.66,4.31-1.75,4.9-.18,1,.11-.28-.07.71a1.34,1.34,0,0,0-.07.27l0,.25a4.42,4.42,0,0,1-.12,1l0-.64c0,.43-.07,1-.08,1.58s.1,1,.11,1.15l-.06-1c.07.69.12,1.42.22,2.16s.32,1.49.52,2.22.53,1.44.84,2.11.7,1.28,1.07,1.84a.66.66,0,0,1-.09-.19,16.07,16.07,0,0,0,2.52,3l-.07-.05c.18.13.36.33.6.49l.74.5c-.49-.29.84.68.2.29a5.05,5.05,0,0,0,1.38.74c.18.06.27.07.95.33l.28.21a13.5,13.5,0,0,1,1.59.46c-.88-.25.64.33-.35.05a10.9,10.9,0,0,0,2.65.77c.7.16,1.24.22,1.76.4.55,0,.05-.11-.51-.2a2.84,2.84,0,0,1-.87-.19c-.24-.09,0-.07.36,0s.9.1,1.26.17a14.37,14.37,0,0,0,3.1.56h-.39c.71.1,1.38,0,2.25.1.48-.12,1.12,0,1.26-.15l-1.73,0c1-.06,1.89-.16,3.5-.23-.13,0-.6.11-.93.16.47,0,.9-.1,1.39-.09a17,17,0,0,1-3.13.29c.51.07,2-.13,1.46,0,.74-.28,1.86-.08,3.11-.4l-.07.11c.2-.05.61-.15,1-.2l-.65.22c1-.28,2-.15,3-.46-2,.42-.48,0-1.35.07a9.6,9.6,0,0,1,2-.33,6.64,6.64,0,0,0,2.26-.44c-.37.13-1.42.36-.85.14s1.24-.31,1.58-.35c1.82-.58-.32,0,.44-.32.67-.05.86-.36,1.62-.7l.05.1c2-.76.47-.36,2.25-1.16l-.67.51.89-.5-.13.21c.95-.6,1.29-.69,2.22-1.28-.26.07,0-.25.81-.77.58-.33-.21.33.86-.52a2,2,0,0,1-1,.77c0,.06-.22.22-.25.28a7.59,7.59,0,0,0,1-.64l.81-.7a5.18,5.18,0,0,1-.43.32c.48-.47,1-.92,1.43-1.4.24-.2.11,0-.06.2.29-.28.43-.54.83-1,0,.17.06.21-.49.87l1.23-1.49c.14,0,.69-.71.57-.49a17.26,17.26,0,0,0,1-1.62c.32-.62.62-1.31.9-2a3.89,3.89,0,0,1,.14-.51,11.3,11.3,0,0,0,.82-4l.21-.89c0-1.24-.19,1.2-.3-.85-.12-1.44.12-.55.13-1.06-.14-.72-.51-1.92-.73-3.24C344.24,294,344.3,294.3,344.41,294.7Zm-8.64-12a4.09,4.09,0,0,1,.93.56A2.08,2.08,0,0,1,335.77,282.74Zm-22-1.63a3.42,3.42,0,0,1,.89-.21A6.15,6.15,0,0,1,313.78,281.11ZM320.23,318h0C319.57,318,319.8,318,320.23,318Zm1.31-.06c.13,0,.12,0,.07,0a4.94,4.94,0,0,1-.72.07A2.22,2.22,0,0,0,321.54,317.92Zm-5.53-1.8.26,0C315.69,316.15,315.85,316.14,316,316.12Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.22,280.35a.2.2,0,0,1,.13,0C316.46,280.35,316.46,280.33,316.22,280.35Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.85,304.06l0,0v0Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,314.07a2.46,2.46,0,0,1-.36-.4S301.68,313.78,302,314.07Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.34,316.7c-.26.08-.53.14-.8.2.39-.09.54-.09.74-.13C328.25,316.75,328.09,316.77,328.34,316.7Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.29,314.56l.33-.2h0C335.12,314.61,334.82,314.82,335.29,314.56Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.16,316.74a4.35,4.35,0,0,0,1.14-.29l-.1,0C330.34,316.35,329.75,316.55,329.16,316.74Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.43,316.4l.51-.17C331,316.17,330.73,316.29,330.43,316.4Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.19,317.7c.28,0,.16-.1.32-.09S321.68,317.92,323.19,317.7Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.67 316.81 329.45 316.79 329.14 316.94 329.67 316.81",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.11,317.77l.94-.13s.1,0,.24-.07C325.72,317.66,325.08,317.75,325.11,317.77Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.29,317.57c.3-.06.58-.13.74-.18Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.43,317.18l-.27.05-.65.14Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,318.4c-.35,0-.69,0-1-.07-.11,0,.17.08.55.1S315.16,318.43,315,318.4Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.12,318.67a1.86,1.86,0,0,1-.45-.06l0,.12Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.1,318.69c-.1.06-1.51,0-.19.08C315,318.74,316.06,318.74,315.1,318.69Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.06 312.7 301.24 312.89 301.37 312.71 301.06 312.7",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.58,300.24c-.05,1.27.12.3.1,1.44,0,.15,0-.09,0-.32s0-.46.05-.31C295.71,300.3,295.74,299.89,295.58,300.24Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.76,301.05c0,.12,0,.25,0,.39Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.92 284.24 310.64 283.92 310.17 284.12 309.92 284.24",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.3,283.63l.17-.07.43-.19Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.94,281.35l-.07,0a6.3,6.3,0,0,0,.6.36A5.08,5.08,0,0,0,333.94,281.35Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.1 288.71 342 288.55 342.06 288.93 342.1 288.71",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.1,297.49c0-.39-.1-.83-.13-1.22C345.1,297.1,344.93,297.6,345.1,297.49Z",
    style: {
      fill: "#3e494e"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.88,
    y: 95.69,
    width: 24.73,
    height: 38.07,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.88,
    y: 95.69,
    width: 24.73,
    height: 38.07,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.53,
    y: 133.76,
    width: 0.5,
    height: 314.82,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.52,
    y: 133.76,
    width: 0.5,
    height: 314.82,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.51,
    y: 133.76,
    width: 0.5,
    height: 314.82,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.5,
    y: 133.76,
    width: 0.5,
    height: 314.82,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.5,
    y: 133.76,
    width: 0.5,
    height: 314.82,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.49,
    y: 133.76,
    width: 0.5,
    height: 314.82,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.48,
    y: 133.76,
    width: 0.5,
    height: 314.82,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.48,
    y: 133.76,
    width: 0.5,
    height: 314.82,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.59,111.94a6.51,6.51,0,1,1-6.51-6.51A6.5,6.5,0,0,1,185.59,111.94Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,111.94a3.94,3.94,0,1,1-3.94-3.94A3.93,3.93,0,0,1,183,111.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.05,
    cy: 111.94,
    r: 6.51,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,111.94a3.94,3.94,0,1,1-3.94-3.94A3.93,3.93,0,0,1,217,111.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.53,111.94a6.51,6.51,0,1,1-6.51-6.51A6.51,6.51,0,0,1,253.53,111.94Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,111.94A3.94,3.94,0,1,1,247,108,3.94,3.94,0,0,1,251,111.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.59,111.94a6.51,6.51,0,1,1-6.51-6.51A6.5,6.5,0,0,1,287.59,111.94Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,111.94a3.94,3.94,0,1,1-3.94-3.94A3.93,3.93,0,0,1,285,111.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.17,
    cy: 111.94,
    r: 6.51,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.11,111.94a3.94,3.94,0,1,1-3.94-3.94A3.94,3.94,0,0,1,319.11,111.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.06,
    cy: 111.94,
    r: 6.51,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,111.94a3.94,3.94,0,1,1-3.94-3.94A3.93,3.93,0,0,1,353,111.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.06,
    cy: 111.94,
    r: 6.51,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,111.94a3.94,3.94,0,1,1-3.94-3.94A3.94,3.94,0,0,1,387,111.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 417.17,
    cy: 111.94,
    r: 6.51,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.11,111.94a3.94,3.94,0,1,1-3.94-3.94A3.94,3.94,0,0,1,421.11,111.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.59,111.94a6.51,6.51,0,1,1-6.51-6.51A6.51,6.51,0,0,1,457.59,111.94Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455,111.94a3.94,3.94,0,1,1-3.94-3.94A3.94,3.94,0,0,1,455,111.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.64,111.94a6.51,6.51,0,1,1-6.51-6.51A6.5,6.5,0,0,1,491.64,111.94Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.07,111.94a3.94,3.94,0,1,1-3.94-3.94A3.93,3.93,0,0,1,489.07,111.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.55,111.94a6.51,6.51,0,1,1-6.51-6.51A6.5,6.5,0,0,1,525.55,111.94Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523,111.94A3.94,3.94,0,1,1,519,108,3.93,3.93,0,0,1,523,111.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.6,111.94a6.51,6.51,0,1,1-6.51-6.51A6.5,6.5,0,0,1,559.6,111.94Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557,111.94a3.94,3.94,0,1,1-3.94-3.94A3.93,3.93,0,0,1,557,111.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 587.07,
    cy: 111.94,
    r: 6.51,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591,111.94a3.94,3.94,0,1,1-3.94-3.94A3.93,3.93,0,0,1,591,111.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.28,98.18c0,3.25-.36,13.83-.36,13.83,0,3.68-5.69,3.67-5.69,0V95.87c0-8.14-3.55-11.07-7.07-11.07-4.4,0-7,5.3-7,10.88h-5.72c0-12.67,6.06-17.56,12.29-17.56C178.2,78.12,182.28,84.44,182.28,98.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.28,98.18c0,3.25-.36,13.83-.36,13.83,0,3.68-5.68,3.67-5.68,0s0-10.17,0-16.14c0-8.14-3.54-11.07-7.07-11.07-4.4,0-7,5.3-7,10.88h-5.72c0-12.67,6.06-17.56,12.29-17.56C212.2,78.12,216.28,84.44,216.28,98.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.29,98.18c0,3.25-.36,13.83-.36,13.83,0,3.68-5.69,3.67-5.69,0V95.87c0-8.14-3.55-11.07-7.08-11.07-4.4,0-7,5.3-7,10.88h-5.72c0-12.67,6.06-17.56,12.29-17.56C246.2,78.12,250.29,84.44,250.29,98.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.29,98.18c0,3.25-.36,13.83-.36,13.83,0,3.68-5.69,3.67-5.69,0V95.87c0-8.14-3.55-11.07-7.07-11.07-4.4,0-7,5.3-7,10.88h-5.72c0-12.67,6.06-17.56,12.29-17.56C280.21,78.12,284.29,84.44,284.29,98.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.29,98.18c0,3.25-.36,13.83-.36,13.83,0,3.68-5.69,3.67-5.69,0V95.87c0-8.14-3.54-11.07-7.07-11.07-4.4,0-7,5.3-7,10.88h-5.72c0-12.67,6.06-17.56,12.29-17.56C314.21,78.12,318.29,84.44,318.29,98.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.3,98.18c0,3.25-.37,13.83-.37,13.83,0,3.68-5.68,3.67-5.68,0V95.87c0-8.14-3.55-11.07-7.08-11.07-4.4,0-7,5.3-7,10.88h-5.72c0-12.67,6.05-17.56,12.29-17.56C348.21,78.12,352.3,84.44,352.3,98.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.3,98.18c0,3.25-.36,13.83-.36,13.83,0,3.68-5.69,3.67-5.69,0V95.87c0-8.14-3.55-11.07-7.08-11.07-4.4,0-7,5.3-7,10.88h-5.72c0-12.67,6.06-17.56,12.29-17.56C382.22,78.12,386.3,84.44,386.3,98.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.3,98.18c0,3.25-.36,13.83-.36,13.83,0,3.68-5.69,3.67-5.69,0V95.87c0-8.14-3.54-11.07-7.07-11.07-4.4,0-7,5.3-7,10.88h-5.72c0-12.67,6.06-17.56,12.29-17.56C416.22,78.12,420.3,84.44,420.3,98.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.31,98.18c0,3.25-.37,13.83-.37,13.83,0,3.68-5.68,3.67-5.68,0s0-10.17,0-16.14c0-8.14-3.54-11.07-7.07-11.07-4.4,0-7,5.3-7,10.88h-5.73c0-12.67,6.06-17.56,12.3-17.56C450.22,78.12,454.31,84.44,454.31,98.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.31,98.18c0,3.25-.36,13.83-.36,13.83,0,3.68-5.69,3.67-5.69,0V95.87c0-8.14-3.55-11.07-7.08-11.07-4.4,0-7,5.3-7,10.88h-5.72c0-12.67,6.06-17.56,12.29-17.56C484.23,78.12,488.31,84.44,488.31,98.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.31,98.18c0,3.25-.36,13.83-.36,13.83,0,3.68-5.69,3.67-5.69,0V95.87c0-8.14-3.54-11.07-7.07-11.07-4.4,0-7,5.3-7,10.88h-5.72c0-12.67,6.06-17.56,12.29-17.56C518.23,78.12,522.31,84.44,522.31,98.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.32,98.18c0,3.25-.37,13.83-.37,13.83,0,3.68-5.68,3.67-5.68,0s0-10.17,0-16.14c0-8.14-3.54-11.07-7.07-11.07-4.4,0-7,5.3-7,10.88h-5.73c0-12.67,6.06-17.56,12.29-17.56C552.23,78.12,556.32,84.44,556.32,98.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.32,98.18c0,3.25-.36,13.83-.36,13.83,0,3.68-5.69,3.67-5.69,0V95.87c0-8.14-3.55-11.07-7.08-11.07-4.4,0-7,5.3-7,10.88h-5.72c0-12.67,6.06-17.56,12.29-17.56C586.24,78.12,590.32,84.44,590.32,98.18Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.33,448.58c201.6-.61,427.74-.62,629.34,0-201.6.62-427.74.61-629.34,0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Notes--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.59,267.5h-39a20.88,20.88,0,0,1-1.93-7.76V228.49h39v31.65C397.66,263.3,399.59,267.5,399.59,267.5Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.36,237.71c4.58-.38,9.17-.47,13.76-.49s9.17.11,13.76.49c-4.59.38-9.17.46-13.76.48S369.94,238.08,365.36,237.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.36,242.85c4.12-.38,8.25-.46,12.38-.48s8.25.1,12.37.48c-4.12.38-8.25.47-12.37.48S369.48,243.23,365.36,242.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.36,248c3.61-.37,7.22-.46,10.82-.48s7.22.1,10.83.48c-3.61.38-7.22.47-10.83.49S369,248.37,365.36,248Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.36,253.14c4.58-.38,9.17-.47,13.76-.49s9.17.11,13.76.49c-4.59.38-9.17.46-13.76.48S369.94,253.51,365.36,253.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.68,372h-39a20.89,20.89,0,0,1-1.93-7.77V333h39v31.65C342.75,367.78,344.68,372,344.68,372Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.45,342.19c4.58-.38,9.17-.47,13.76-.49s9.17.11,13.76.49c-4.59.37-9.17.46-13.76.48S315,342.56,310.45,342.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.45,347.33c4.12-.38,8.25-.46,12.37-.48s8.26.1,12.38.48c-4.12.38-8.25.47-12.38.48S314.57,347.71,310.45,347.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.45,352.47c3.6-.37,7.21-.46,10.82-.48s7.22.1,10.83.48c-3.61.38-7.22.47-10.83.49S314.05,352.85,310.45,352.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.45,357.62c4.58-.38,9.17-.47,13.76-.49s9.17.11,13.76.49c-4.59.37-9.17.46-13.76.48S315,358,310.45,357.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.53,266.8h-39a20.81,20.81,0,0,1-1.94-7.77V227.79h39v31.65C286.59,262.6,288.53,266.8,288.53,266.8Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.29,237c4.59-.38,9.18-.47,13.77-.49s9.17.11,13.76.49c-4.59.37-9.18.46-13.76.48S258.88,237.38,254.29,237Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.29,242.15c4.13-.38,8.26-.46,12.38-.48s8.25.1,12.38.48c-4.13.38-8.25.46-12.38.48S258.42,242.53,254.29,242.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.29,247.29c3.61-.37,7.22-.46,10.83-.48s7.22.1,10.83.48c-3.61.38-7.22.47-10.83.49S257.9,247.67,254.29,247.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.29,252.44c4.59-.38,9.18-.47,13.77-.49s9.17.11,13.76.49c-4.59.37-9.18.46-13.76.48S258.88,252.81,254.29,252.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.94,424.27h-31a54.09,54.09,0,0,1-.67-7.76V385.26h39v31.65C450.26,420.07,442.94,424.27,442.94,424.27Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.26,416.9c0,3.08-6.88,7.1-7.31,7.35,1.14-.77.95-6.88.95-6.88S450.15,416.56,450.26,416.9Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417,394.48c4.58-.38,9.17-.47,13.76-.49s9.17.11,13.76.49c-4.59.38-9.17.46-13.76.48S421.58,394.85,417,394.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417,399.62c3.6-.38,7.21-.46,10.82-.48s7.22.1,10.83.48a106,106,0,0,1-10.83.48C424.21,400.08,420.6,400,417,399.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417,404.76c3.6-.37,7.21-.46,10.82-.48s7.22.11,10.83.48c-3.61.38-7.22.47-10.83.49S420.6,405.14,417,404.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.36,318.61h-31a54.32,54.32,0,0,1-.67-7.77V279.6h39v31.65C555.69,314.41,548.36,318.61,548.36,318.61Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.68,311.24c0,3.08-6.88,7.1-7.3,7.35,1.14-.77.94-6.88.94-6.88S555.57,310.89,555.68,311.24Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.42,288.82c4.58-.38,9.17-.47,13.76-.49s9.18.11,13.76.49c-4.58.37-9.17.46-13.76.48S527,289.19,522.42,288.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.42,294c3.61-.38,7.22-.46,10.82-.48a106,106,0,0,1,10.83.48c-3.61.38-7.22.46-10.83.48S526,294.34,522.42,294Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.42,299.1c3.61-.37,7.22-.46,10.82-.48s7.22.1,10.83.48c-3.61.38-7.22.47-10.83.49S526,299.48,522.42,299.1Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M649.22,386.78s16.84-3.81,26.07-12.32,14.38-23.73,14.38-23.73a143.76,143.76,0,0,0-18.88,5,31.71,31.71,0,0,0-5.72,8.08,39,39,0,0,1,0-5.78,25.94,25.94,0,0,0-6,3.64C651.38,368.33,649.22,386.78,649.22,386.78Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.16,358.13c2.29-1.59,4.63-3.12,6.91-4.72a.13.13,0,0,0-.14-.22c-4.33,2.59-8.61,5.36-12.75,8.26-1.44,1-2.86,2.06-4.26,3.13l.29-.49c.51-.85,1-1.68,1.57-2.51a36,36,0,0,1,3.58-4.77c0-.05,0-.13-.08-.08-1.31,1.51-2.62,3-3.82,4.61-.57.77-1.1,1.55-1.6,2.36-.26.42-.52.84-.76,1.27l-.25.44c-2.18,1.71-4.3,3.49-6.32,5.38-1.25,1.16-2.45,2.37-3.62,3.61.65-2,1.22-4.1,2-6.11,0-.06-.09-.09-.11,0-.74,2.1-1.54,4.22-2.11,6.38-1.29,1.39-2.52,2.83-3.68,4.34l.06-.28q.29-1.18.6-2.37c.41-1.52.86-3,1.37-4.53a26.3,26.3,0,0,1,4.53-8.54c0-.06,0-.14-.09-.08A32.92,32.92,0,0,0,654,376.65q-.27,1.08-.51,2.16c-.09.38-.19.77-.25,1.17-.51.68-1,1.38-1.49,2.09a73.22,73.22,0,0,0-7.12,14,159.8,159.8,0,0,0-5.4,16.82.09.09,0,0,0,.17.05c3.3-9.86,6.66-19.85,12.3-28.66,1.19-1.86,2.48-3.65,3.84-5.37a31.76,31.76,0,0,0,8.19-1.64,35.93,35.93,0,0,0,8.21-4,47.73,47.73,0,0,0,4.2-3.18.05.05,0,1,0-.07-.08,33.89,33.89,0,0,1-7.72,4.67,41.53,41.53,0,0,1-8.49,2.84c-1.24.28-2.5.48-3.77.65a71.89,71.89,0,0,1,5-5.5c.57-.57,1.16-1.11,1.74-1.66a40.38,40.38,0,0,1,6.22-3.57c2.76-1.33,5.48-2.74,8.21-4.13,1.54-.79,3.07-1.59,4.62-2.35.07,0,0-.13-.06-.09-2.77,1.33-5.58,2.58-8.37,3.86-2.63,1.21-5.29,2.42-7.81,3.83l-.32.19q3.42-3,7.06-5.7C674.59,361.37,676.85,359.72,679.16,358.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.2,366.81c-1.37.6-2.77,1.14-4.12,1.77a45.12,45.12,0,0,0-4,2.2c-.06,0,0,.11.06.08,1.34-.64,2.7-1.24,4-1.91s2.71-1.41,4.1-2C678.3,366.89,678.27,366.78,678.2,366.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.52,302.46a24.11,24.11,0,0,1,5,14c.05,1.51-.19,3.61-.36,6.08a40.09,40.09,0,0,1,11,9.39,19.94,19.94,0,0,0-11.11-2.65,32.41,32.41,0,0,0,.65,5,18.9,18.9,0,0,1,7.14,1.41,16,16,0,0,0-6.44,1.28c3,9.55,11.92,19.36,36.56,23.52a51.67,51.67,0,0,0-4.37-34.66C625.24,311.33,594.52,302.46,594.52,302.46Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.51,400.84q-.64-6.12-1.59-12.2a244.22,244.22,0,0,0-5-24.11,95.85,95.85,0,0,0-3.56-11,16.24,16.24,0,0,0,.09-2c0-.79,0-1.58,0-2.37,0-1.58-.1-3.15-.23-4.72a57.62,57.62,0,0,0-1.51-9.24c-.45-1.76-1-3.48-1.49-5.22a.06.06,0,0,0-.11,0,68.94,68.94,0,0,1,1.82,9.22,86.81,86.81,0,0,1,.82,9.25c0,.84.05,1.69.05,2.54,0,.36,0,.72,0,1.09a78.12,78.12,0,0,0-4.15-8.6,104.09,104.09,0,0,0-8.43-12.61,5.35,5.35,0,0,0-.2-1.38l-.36-1.65c-.25-1.12-.54-2.24-.84-3.35-.61-2.24-1.42-4.39-2.12-6.6a.06.06,0,0,0-.11,0c.65,2.19,1.08,4.45,1.58,6.67.25,1.1.49,2.2.73,3.3.12.55.24,1.1.35,1.65l0,.12q-1.5-1.89-3-3.71c-4.71-5.52-9.87-10.61-15.06-15.66-.64-.62-1.29-1.23-1.94-1.84,0,0-.13,0-.08.08,5,5.18,9.85,10.41,14.48,15.89q1.65,2,3.24,4l-1.68-1.12c-1.43-.93-2.88-1.85-4.38-2.68s-3-1.66-4.54-2.42-3.27-1.42-4.79-2.31c-.06,0-.12.07,0,.1a37.12,37.12,0,0,1,4.49,2.49c1.5.89,3,1.79,4.47,2.72s2.9,1.82,4.34,2.76c1.2.78,2.38,1.63,3.62,2.35a116.71,116.71,0,0,1,7.89,11.48,84.09,84.09,0,0,1,4.08,7.74l-.88-.38-2.26-1c-1.44-.65-2.9-1.27-4.35-1.91-2.77-1.2-5.57-2.3-8.28-3.62a37.54,37.54,0,0,1-4.43-2.46c-.06,0-.11.06,0,.1,5,3.49,10.71,5.94,16.3,8.41l2.43,1.08c.66.29,1.33.62,2,.88A85.87,85.87,0,0,1,637,362.07a228.67,228.67,0,0,1,5.36,23.84c1.42,8,2.37,16.14,3.11,24.28.09,1,.18,2,.3,3a.32.32,0,0,0,.64,0C646.37,409.08,645.94,405,645.51,400.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.52,332.81c-.45-2.5-1.11-4.95-1.79-7.4a.06.06,0,1,0-.11,0c.62,2.41,1.07,4.86,1.52,7.3s.87,5,1.22,7.5c0,0,.07,0,.07,0A63.86,63.86,0,0,0,630.52,332.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.91,339.6a45.39,45.39,0,0,0-5.36-3c-.9-.47-1.81-.91-2.72-1.35s-1.91-.83-2.84-1.3c-.06,0-.12.07,0,.1.9.45,1.75,1,2.64,1.48l2.73,1.5a60,60,0,0,0,5.46,2.82A.14.14,0,0,0,619.91,339.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.53,357.62s15.58-3.72,22.73-14.17c6.83-10,9-27,9.21-28.5-.28,1.38-3.49,16.25-14.1,23.17C659.25,343.43,651.4,347.79,649.53,357.62Z",
    style: {
      fill: "#263238",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.91,330.7a19.9,19.9,0,0,0-5.75,9.46s0,0,.05,0a23.2,23.2,0,0,1,5.77-9.39C664,330.73,664,330.65,663.91,330.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.53,358.15s15.58-3.72,22.73-14.18c6.83-10,9-27,9.21-28.49a.42.42,0,0,0,0-.1S674,326,666.17,328.71,647.27,340.79,649.53,358.15Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.73,320.71a63.85,63.85,0,0,1-4.81,8.23,33.41,33.41,0,0,1-6.41,6.6c-2.12,1.68-4.36,3.2-6.5,4.85l0-.08c.4-.59.83-1.17,1.27-1.74.9-1.14,1.87-2.22,2.85-3.28,1.94-2.1,3.91-4.16,5.65-6.44a23.87,23.87,0,0,0,2.5-4c0-.07-.08-.1-.11,0-2.53,5.27-7.57,8.64-11.18,13.08-.51.64-1,1.29-1.44,2a8.22,8.22,0,0,0-.89,1.59,32.56,32.56,0,0,0-5.32,5.37,21.87,21.87,0,0,1,.63-3,15.23,15.23,0,0,1,1.65-3.95c0-.06-.06-.13-.1-.06a18.33,18.33,0,0,0-1.81,3.92,13.36,13.36,0,0,0-.57,3.36h0a29.74,29.74,0,0,0-2.1,3.27c.06-.33.12-.66.19-1,.31-1.56.65-3.1,1.05-4.64a27.73,27.73,0,0,1,3.75-8.77c0-.06-.05-.13-.09-.07a33.45,33.45,0,0,0-4.16,8.59c-.49,1.53-.89,3.09-1.24,4.65-.17.77-.32,1.54-.47,2.31-.08.4-.16.81-.23,1.22a55.71,55.71,0,0,0-3.59,10.56,154.6,154.6,0,0,0-3.32,19.7,164.26,164.26,0,0,0-1.08,20.92c0,.87.07,1.75.12,2.62,0,.23.35.26.36,0,.15-3.45.24-6.91.44-10.37s.51-6.9.88-10.35a182.79,182.79,0,0,1,3.25-20.14c1.26-5.7,2.9-11.43,6-16.42a31.06,31.06,0,0,1,5.62-6.69c2.18-2,4.57-3.68,6.88-5.49a37.76,37.76,0,0,0,6.31-6.07,49.47,49.47,0,0,0,5-8c.37-.7.74-1.41,1.12-2.11C678.86,320.71,678.76,320.64,678.73,320.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676,323a52,52,0,0,1-3.47,6.07,0,0,0,0,0,.07.05,42.26,42.26,0,0,0,3.51-6.08C676.18,323,676.07,322.93,676,323Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.35,351.26s-.25,22.14,13,28.53,20.34,1.07,29.34,3.21h0c-.35-.53-6.77-9.76-17-12.3C607.18,368.07,595.54,360.48,592.35,351.26Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.35,351.26s-.25,22.14,13,28.53,20.34,1.07,29.34,3.21h0a49.67,49.67,0,0,0-15-4.44C611.26,377.54,595.31,372.1,592.35,351.26Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.55,382.86a22.41,22.41,0,0,0-5.27-3.56c-.28-.14-.57-.25-.86-.37a5.47,5.47,0,0,0-.45-.51c-.39-.41-.81-.81-1.24-1.18a17.86,17.86,0,0,0-2.67-1.92c-2.19-1.29-4.59-2.2-6.84-3.39-.06,0-.12.06-.05.1,1.11.57,2.18,1.21,3.26,1.84s2.12,1.19,3.14,1.85a21.87,21.87,0,0,1,2.62,2c.23.2.46.42.68.65a34.64,34.64,0,0,0-4.47-1.19c-2.43-.49-4.88-.84-7.3-1.35a35.66,35.66,0,0,1-3.51-.95c-1.1-.89-2.19-1.77-3.23-2.72a26.89,26.89,0,0,1-3.43-3.8c0-.06-.14,0-.09.06a40.47,40.47,0,0,0,5.42,6c-.57-.22-1.13-.45-1.69-.7a27.33,27.33,0,0,1-11.28-9.39c0-.06-.14,0-.1.06a31,31,0,0,0,9.13,8.76,27.44,27.44,0,0,0,5.77,2.73,54.79,54.79,0,0,0,7.16,1.7,49.76,49.76,0,0,1,7,1.67,20.81,20.81,0,0,1,5.88,3.09,27.51,27.51,0,0,1,7.93,9.84,49.14,49.14,0,0,1,4.37,16.19c0,.23.4.23.38,0C645.21,399,642.72,389.33,635.55,382.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.18,375.64a7.57,7.57,0,0,0-2.72-2.46,10,10,0,0,1-3.23-2.68c-.05-.06-.15,0-.1.06a10.92,10.92,0,0,0,2.86,2.56,9.81,9.81,0,0,1,3.11,2.58A.05.05,0,1,0,620.18,375.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "627.21 399.2 627.81 411.38 629.66 448.58 657.43 448.58 659.27 411.38 659.88 399.2 627.21 399.2",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "627.21 399.2 627.81 411.38 659.27 411.38 659.88 399.2 627.21 399.2",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625.26,
    y: 394.12,
    width: 36.56,
    height: 11.61,
    transform: "translate(1287.09 799.86) rotate(180)",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M590.52,164c-.63,11-1.46,22.29-3.77,33.07-1.8,8.4-6.16,15-15.22,16.08-8.41,1-20.06-.46-26.37-6.67-2.94-2.89-3.66-6.59-3-10.57.92-5.53,8.77-35.5,11.16-44.85a175.4,175.4,0,0,1,5.33-16.87c5.06-13.85,17.19-12.54,23.3-9.81a12.45,12.45,0,0,1,6.78,7.56C592.24,141.9,591.1,153.73,590.52,164Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.43,125c-7.35,2.47-9.88,9.91-12.34,16.55-3.43,9.25-6.7,18.55-9.51,28-1.36,4.54-2.61,9.12-3.72,13.73-1.07,4.41-2.48,9.09-2.69,13.64-.35,7.54,6.11,11.71,12.61,13.52a.26.26,0,0,0,.16-.49c-3.69-1.17-7.43-2.65-9.92-5.77-3.2-4-2.25-8.64-1.3-13.26,1.62-7.86,3.69-15.62,6-23.3s5-15.28,7.7-22.84c2.61-7.19,5-16.77,13-19.67C568.54,125,568.51,124.92,568.43,125Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.05,140.31c-.68-5.86-3-11.76-8.85-14.1,0,0,0,0,0,0,7.49,3.35,8.43,12.06,8.66,19.27.25,7.6.2,15.19-.11,22.78-.29,7.3-.75,14.65-1.71,21.89-1,7.82-3.29,15-8.64,20.94-.11.12.05.3.17.19,5.15-4.71,7.47-11.74,8.6-18.44A202.55,202.55,0,0,0,591.4,166C591.69,157.54,592,148.76,591.05,140.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.54,384.28s-.1,42.18-.1,42.2c-.24,7.79-.59,14.62-1.1,18.13a.13.13,0,0,1,0,.06,5.34,5.34,0,0,1-.65,2.39l0,.05c-2.37,1.5-64.68,1.39-66.86.66s-.24-7,2.18-8.91,26.3-12.56,26.3-12.56l.49-42.14Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.74,418.12s-.3,8.34-.3,8.36c-.24,7.79-.59,14.62-1.1,18.13a.13.13,0,0,1,0,.06,10.76,10.76,0,0,1-.65,2.39l0,.05c-2.37,1.5-64.68,1.39-66.86.66s-.24-7,2.18-8.91,26.3-12.56,26.3-12.56l.19-8.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.45,426.22c4.16-.57,9.18.31,12.19,3.41.12.12,0,.28-.18.23a58.55,58.55,0,0,0-12-3.12A.26.26,0,0,1,570.45,426.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.38,427.87c4.17-.57,9.18.31,12.2,3.41.11.12-.06.28-.19.23a58.55,58.55,0,0,0-12-3.12A.26.26,0,0,1,567.38,427.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.31,429.52c4.17-.57,9.19.31,12.2,3.41.11.12-.06.28-.19.23a58.38,58.38,0,0,0-12-3.12A.26.26,0,0,1,564.31,429.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.78,447.77c2.18.74,64.49.84,66.86-.66.91-.56,1.45-9.64,1.8-20.63v-.34l-40.19-.52v.69S550.4,436.93,548,438.86,543.61,447,545.78,447.77Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.45,426.13v.36c-.35,11-.89,20.06-1.8,20.62-1.08.68-14.59,1-29.19,1.15-17.47.13-36.48-.09-37.67-.49-2.17-.73-.23-7,2.18-8.91s26.3-12.56,26.3-12.56v-.67l13.4.17Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.49,445.35c10.51-.24,52.89-.21,63.29.35.09,0,.09.06,0,.06-10.4.47-52.79.1-63.29-.23C546.27,445.52,546.27,445.36,546.49,445.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.65,425.8c-1.17,6.7-2.94,16.58-4.2,22.46-17.47.13-36.48-.09-37.67-.49-2.17-.73-.23-7,2.18-8.91s26.3-12.56,26.3-12.56v-.67Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618,427l-45.07-.81s-.35-77.77.13-102.25c.55-27.94,4.45-111.73,4.45-111.73l33.68.93s6.7,19.62,6,31.69c-.2,3.49-2.54,8.56-3.57,12.27l-5.39,69.29Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.84,419a33.17,33.17,0,0,0-3.58-.38c-1.33-.13-2.66-.27-4-.36-2.56-.18-5.12-.3-7.69-.38-5.17-.16-10.34-.26-15.52-.25-2.95,0-5.89.05-8.83.14a.09.09,0,0,0,0,.18c5.12.33,10.25.55,15.38.79s10.25.49,15.38.53c1.47,0,2.94,0,4.41,0s3,.08,4.41-.1C614.9,419.2,614.94,419.06,614.84,419Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.58,376c-.19-12.15-.16-27.19-.16-39.34q0-36.43,1.49-72.86c.54-13.62,1.29-27.23,2.07-40.83,0-.16-.23-.16-.24,0-2,24.34-3.13,48.75-3.83,73.17s-.95,51.48-.42,75.77c.3,13.63.66,28.72,1.56,42.33a.1.1,0,0,0,.19,0C578,402,577.77,388.31,577.58,376Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.23,385.51s-1.47,40.73-1.47,40.76c-.24,7.79-.59,14.61-1.1,18.13a.13.13,0,0,1,0,.06,5.28,5.28,0,0,1-.65,2.38.1.1,0,0,1,0,.05c-2.37,1.5-64.68,1.4-66.85.66s-.25-7,2.17-8.91,26.31-12.55,26.31-12.55l1.85-40.7Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.06,417.91s-.3,8.33-.3,8.36c-.24,7.79-.59,14.61-1.1,18.13a.13.13,0,0,1,0,.06,10,10,0,0,1-.65,2.38.1.1,0,0,1,0,.05c-2.37,1.5-64.68,1.4-66.85.66s-.25-7,2.17-8.91,26.31-12.55,26.31-12.55l.19-8.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.77,426c4.17-.57,9.18.31,12.2,3.4.11.12-.06.29-.19.24a58.55,58.55,0,0,0-12-3.12A.26.26,0,0,1,520.77,426Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.7,427.66c4.17-.57,9.19.31,12.2,3.4.11.12-.06.29-.19.24a58.38,58.38,0,0,0-12-3.12A.26.26,0,0,1,517.7,427.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.64,429.31c4.16-.57,9.18.31,12.19,3.4.12.12-.06.29-.19.24a58.45,58.45,0,0,0-12-3.12A.26.26,0,0,1,514.64,429.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.11,447.55c2.17.74,64.48.84,66.85-.66.91-.55,1.46-9.63,1.8-20.62,0-.12,0-.23,0-.34l-40.2-.52v.68s-23.86,10.63-26.3,12.56S493.93,446.83,496.11,447.55Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.82,445.14c10.5-.24,52.88-.22,63.29.34.08,0,.08.06,0,.07-10.41.46-52.79.1-63.3-.24C496.59,445.3,496.59,445.14,496.82,445.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.42,255.75S570.33,313.5,569.7,324.2c-.54,9.12-2,102.82-2,102.82l-44-1s7-96.79,8-106.28c1.57-15,9.65-48.93,20.35-85.64,2-6.87,8.5-22.32,8.5-22.32l49.57,1.37s-1.07,22.77-11.89,39C598.22,252.1,593.47,254.14,590.42,255.75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.5,418.58c-4.93-.27-10-.54-15-.57s-9.82-.09-14.71,0c-2.78.07-5.55.08-8.33.25a.07.07,0,1,0,0,.13c4.93.4,9.88.48,14.83.58s9.8.18,14.71.12c2.77,0,5.54-.09,8.32-.19C565.63,418.92,565.8,418.59,565.5,418.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.2,239.23c-1.82,5.52-3.39,11.13-5,16.7s-3.32,11.24-5,16.87c-3.19,10.88-8.07,29.13-10.54,40.2s-9.56,98.92-9.55,100.37a.11.11,0,0,0,.22,0c1.36-10.2,9-95.6,10.09-99.58,3-10.92,6.2-26.17,9.36-37.06,1.8-6.21,3.62-12.41,5.41-18.63s3.73-12.48,5.34-18.79A.17.17,0,0,0,560.2,239.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.69,252.32a42.57,42.57,0,0,0,6.94.74c2.36,0,4.63-.31,7-.52a51.58,51.58,0,0,1,6.69.22,23,23,0,0,0,6.72-.63.08.08,0,1,1,0,.16,40.12,40.12,0,0,1-6.61,1.43c-2.31.25-4.6-.1-6.92,0a56.24,56.24,0,0,1-7.11.21,25,25,0,0,1-6.78-1.46C578.55,252.44,578.61,252.31,578.69,252.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.68,302.61c.52-1.77,1-3.56,1.56-5.33,1.11-3.58,2.24-7.16,3.46-10.71,2.43-7.05,4.73-14.14,7.29-21.15,1.44-4,2.76-8,4.43-11.89a.08.08,0,0,1,.16.05c-.89,3.64-2.1,7.2-3.2,10.79s-2.27,7.15-3.44,10.72c-2.33,7.08-4.61,14.18-7.14,21.2q-1,3-2.19,5.88c-.77,2-1.4,4.05-2.32,6a.09.09,0,0,1-.17-.06C573.5,306.24,574.14,304.44,574.68,302.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.25,242.86c.32-3.06,1.35-12.74,1.52-14.51.08-.89.45-6,.1-6.08a44.67,44.67,0,0,0-5.55-.1c-1.81,0-3.62-.1-5.42-.19-3.66-.2-7.32-.56-10.95-1a.38.38,0,1,0-.1.76q5.5.81,11.06,1.2c1.8.13,8.79.49,10.41.31,0,.73-.49,3.42-.56,4a22.21,22.21,0,0,0-2.31.15q-1.29.09-2.58.12c-1.78,0-3.57,0-5.35-.06a82.55,82.55,0,0,1-10.29-1.1.08.08,0,1,0,0,.15,60,60,0,0,0,10.5,1.45q2.49.12,5,0c.9,0,1.8-.08,2.7-.14a17.88,17.88,0,0,0,2.32-.24c0,.11,0,.23,0,.35-.22,1.69-1.34,11.64-1.72,14.92-1.84.84-10.82,5-11.87,4.39-2-1.08-8.87-5.68-10.88-6.81.28-2.95.66-5.88,1.16-8.8.26-1.5.54-3,.86-4.48a28.93,28.93,0,0,0,.84-4.59c0-.13-.19-.24-.28-.11l-.14.18a.09.09,0,0,0,0,.1,20.84,20.84,0,0,0-1.29,4.06c-.39,1.52-.73,3-1,4.58q-.93,4.61-1.44,9.27a.58.58,0,0,0,.26.54c3,1.77,11.3,7.1,12.06,7.24,1.46.27,12.41-4.48,12.7-4.67S589.21,243.24,589.25,242.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602,240.51c-.25-2.63-1-11-1.16-12.48-.07-.77-.38-5.18-.18-5.2a17.91,17.91,0,0,1,3.16.27c1,.08,2.07.14,3.1.17a51.58,51.58,0,0,0,6.22-.21c.31,0,.38.63.07.66a57.18,57.18,0,0,1-6.28.34,44.45,44.45,0,0,1-5.94-.39c0,.63.35,3,.4,3.48a9,9,0,0,1,1.33.27c.49.1,1,.19,1.47.26a28.59,28.59,0,0,0,3.05.29,31.7,31.7,0,0,0,5.85-.3c.06,0,.07.11,0,.13a22.51,22.51,0,0,1-6,.58,24.82,24.82,0,0,1-2.84-.28c-.52-.09-1-.18-1.54-.3a6.21,6.21,0,0,1-1.33-.35l0,.31c.16,1.46,1,10,1.28,12.84,1.06.84,6.27,4.92,6.86,4.5,1.12-.81,4.95-4.3,6.07-5.14-.22-2.53-.49-5.06-.84-7.58-.18-1.3-.37-2.59-.58-3.89a38.33,38.33,0,0,1-.57-4c0-.11.1-.19.16-.07l.08.16a.14.14,0,0,1,0,.09,26,26,0,0,1,.82,3.54c.25,1.32.48,2.65.69,4q.62,4,1,8a.57.57,0,0,1-.13.45C614.6,242,610,246,609.55,246.1c-.83.13-7.17-4.6-7.34-4.79A1.24,1.24,0,0,1,602,240.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.27,234.48c-.07-4.56-.18-9.13-.47-13.69-.17-2.62-.36-5.25-.62-7.87,0-.09-.15-.1-.15,0,.22,4.6.43,9.2.6,13.8s.17,9.13.22,13.7c0,2.63,0,5.25.06,7.88a.08.08,0,1,0,.15,0C597.31,243.7,597.35,239.09,597.27,234.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.56,211.77l-32.13,2.55a56.29,56.29,0,0,1-1.33-8c-.64-8.09-2.57-32.37-2.57-32.37l40.42-3.2,2.6,32.79C507.81,206.83,500.56,211.77,500.56,211.77Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.54,203.54c.26,3.19-6.54,7.92-7,8.21,1.11-.89.41-7.2.41-7.2S507.39,203.19,507.54,203.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.24,183c4.72-.77,9.46-1.23,14.22-1.63s9.51-.65,14.29-.63c-4.72.77-9.46,1.24-14.21,1.63S476,183.05,471.24,183Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.66,188.37c3.71-.69,7.44-1.07,11.18-1.39a111.08,111.08,0,0,1,11.26-.39A111.18,111.18,0,0,1,482.92,188C479.18,188.26,475.43,188.46,471.66,188.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.08,193.7a126.53,126.53,0,0,1,22.44-1.78c-3.71.69-7.44,1.07-11.18,1.39S475.85,193.79,472.08,193.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.38,160.26c0,1-2.74,8.21-7,9.17-1.4.31-3.43-7.24-3.43-7.24l-.28-.53-3.87-7.33,7.56-8.38,1.11-1.14s.93,2.08,2.06,4.67c.06.12.11.24.16.37a3.89,3.89,0,0,1,.19.42c.18.38.35.78.52,1.18s.25.59.38.91l.38.95A53.55,53.55,0,0,1,586.38,160.26Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.5,149.48a16.6,16.6,0,0,1-6.86,12.18l-3.87-7.33,7.56-8.38,1.11-1.14S581.37,146.89,582.5,149.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.77,143.07c-.21,15,8.78,16.8,12,16.83,3,0,13-.25,14.73-15.16s-5.17-19.73-11.9-20.15S557,128.06,556.77,143.07Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.23,141.64a8.85,8.85,0,0,0,1-.27,1.74,1.74,0,0,0,1-.47.54.54,0,0,0,0-.65,1.33,1.33,0,0,0-1.33-.24,2,2,0,0,0-1.18.76A.57.57,0,0,0,558.23,141.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.25,140.68a8.81,8.81,0,0,1-1-.15,1.65,1.65,0,0,1-1-.36.54.54,0,0,1,0-.65,1.32,1.32,0,0,1,1.29-.38,2,2,0,0,1,1.26.61A.57.57,0,0,1,568.25,140.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.2,143.7s.08,0,.08.08c0,1,.18,2.2,1.11,2.5,0,0,0,.06,0,.06C566.25,146.22,566,144.66,566.2,143.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.08,142.6c1.64-.19,1.88,3.1.36,3.27S565.7,142.75,567.08,142.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.74,142.72c.3.17.6.47,1,.48s.69-.36.93-.71c0,0,0,0,.06,0,.05.63-.15,1.29-.82,1.44s-1.09-.4-1.3-1C567.53,142.84,567.62,142.66,567.74,142.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.49,143.63s-.08.06-.07.1c.11,1,.07,2.2-.83,2.61,0,0,0,.07,0,.06C560.72,146.15,560.76,144.58,560.49,143.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.49,142.65c-1.65,0-1.52,3.3,0,3.29S560.88,142.64,559.49,142.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.81,142.89c-.25.19-.5.52-.81.55s-.64-.3-.89-.64c0,0-.05,0-.05,0,0,.63.25,1.28.86,1.37s.94-.47,1.07-1.1C559,143,558.91,142.82,558.81,142.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.85,152.3c-.21.27-.42.62-.78.7a2.68,2.68,0,0,1-1.12-.13s-.07,0,0,.06a1.36,1.36,0,0,0,1.35.4,1.1,1.1,0,0,0,.7-1C567,152.27,566.89,152.26,566.85,152.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.36,148.88s-.12,1.54-.08,2.26c0,.06.18.09.43.08h0a3.43,3.43,0,0,0,3.24-1.48c0-.07-.05-.14-.11-.09a5.24,5.24,0,0,1-3.07,1.09c-.06-.2.29-2.63.18-2.63a6.49,6.49,0,0,0-1.62.47c.16-3.2.82-6.36.93-9.56a.1.1,0,0,0-.19,0,52,52,0,0,0-1.44,10.25C560.63,149.66,562.08,149,562.36,148.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.76,151a4.12,4.12,0,0,0,1.67,1.28,1.81,1.81,0,0,0,1.13.07c.82-.22.84-1,.69-1.61a4.18,4.18,0,0,0-.37-1A5.35,5.35,0,0,1,562.76,151Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.43,152.23a1.81,1.81,0,0,0,1.13.07c.82-.22.84-1,.69-1.61A1.92,1.92,0,0,0,564.43,152.23Z",
    style: {
      fill: "#ff9abb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.58,145.56a6.18,6.18,0,0,1-4.13-4.53,16.3,16.3,0,0,1-7.27-4.36c.15.3,1.17,2.42,1.73,3.48-9.73-.46-13.65-7.29-13.65-7.29a16.58,16.58,0,0,0-3.32,6.56s-.85-5.79,1.61-10.09a9.5,9.5,0,0,1,8.13-5.05,13.55,13.55,0,0,1,13.64,2.22C587.39,132.34,583.58,145.56,583.58,145.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.48,139.58a17.71,17.71,0,0,0,5.11,1.11s0,0,0,0a15.08,15.08,0,0,1-7.53-3.24,14.08,14.08,0,0,1-2.43-2.57,9.63,9.63,0,0,1-1.75-3.43.08.08,0,0,0-.15,0,11.55,11.55,0,0,0,1.26,3.62,10.42,10.42,0,0,0,2.53,2.84,12.15,12.15,0,0,0,3,1.66",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.12,145.87s2.93-4.92,5.14-3.92.24,8-2.18,9.08a2.54,2.54,0,0,1-3.5-1.1Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.65,143.93s.05,0,0,.07a6.44,6.44,0,0,0-3,4.25,1.42,1.42,0,0,1,2.07-.54s0,.1,0,.1a1.57,1.57,0,0,0-1.68.67,7.54,7.54,0,0,0-.72,1.45c-.07.16-.36.1-.31-.09v0C581.76,147.58,583.27,144.34,585.65,143.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.54,211.88l2.19-13.55A18.23,18.23,0,0,1,559,187.94s0-.09,0-.13a4.86,4.86,0,0,1,0-.54c.12-7.72,11.5-21.16,13.57-23.84a25.11,25.11,0,0,1,2.49-2.77c.35-.32.7-.64,1.06-.92,4.81-3.93,10.19-4.19,15.15.21.36.31.71.66,1.06,1,.11.1.21.21.31.32,2.84,3.07,5.36,7.51,7.55,12.53q.21.45.39.9c.91,2.12,1.75,4.32,2.54,6.56h0c.09.25.18.5.26.75h0a217.3,217.3,0,0,1,7.83,31.14Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.86,166.81a.76.76,0,0,1-.77.74.76.76,0,1,1,.77-.74Zm7.51-.59a.74.74,0,0,0-.76.73.75.75,0,1,0,.76-.73Zm8.25.17a.75.75,0,1,0,.74.76A.76.76,0,0,0,587.62,166.39Zm8.25.17a.75.75,0,1,0,0,1.5.74.74,0,0,0,.76-.73A.75.75,0,0,0,595.87,166.56Zm-19.79-6.82c-.36.28-.71.6-1.06.92a.67.67,0,0,0,.34.1.75.75,0,0,0,.77-.74A.82.82,0,0,0,576.08,159.74Zm7.56-.31a.75.75,0,1,0,.74.76A.76.76,0,0,0,583.64,159.43Zm7.59.52a.8.8,0,0,0-.11.38.75.75,0,0,0,.74.77.71.71,0,0,0,.43-.13C591.94,160.61,591.59,160.26,591.23,160Zm-28.65,19.9a.75.75,0,1,0,.74.76A.75.75,0,0,0,562.58,179.85Zm8.25.17a.75.75,0,1,0,.74.77A.75.75,0,0,0,570.83,180Zm8.25.17a.76.76,0,0,0-.77.74.76.76,0,0,0,1.51,0A.76.76,0,0,0,579.08,180.19Zm8.25.17a.76.76,0,1,0,0,1.51.74.74,0,0,0,.76-.74A.76.76,0,0,0,587.33,180.36Zm8.25.18a.75.75,0,1,0,.73.76A.74.74,0,0,0,595.58,180.54Zm7.5.75a.77.77,0,0,0,0,.15.72.72,0,0,0,.28.6C603.26,181.79,603.17,181.54,603.08,181.29Zm-36.23-8.23a.75.75,0,1,0,0,1.5.75.75,0,1,0,0-1.5Zm8.25.17a.76.76,0,0,0-.77.74.74.74,0,0,0,.74.76.76.76,0,0,0,.77-.73A.76.76,0,0,0,575.1,173.23Zm8.25.17a.76.76,0,0,0,0,1.51.76.76,0,0,0,0-1.51Zm8.25.18a.75.75,0,1,0,.73.76A.74.74,0,0,0,591.6,173.58Zm8.55.24a.73.73,0,0,0-.3-.07.75.75,0,0,0,0,1.5.72.72,0,0,0,.73-.53Q600.36,174.27,600.15,173.82Zm-37.86,20a.76.76,0,1,0,.74.77A.76.76,0,0,0,562.29,193.82Zm8.25.18a.75.75,0,1,0,.74.76A.76.76,0,0,0,570.54,194Zm8.25.17a.75.75,0,1,0,0,1.5.74.74,0,0,0,.76-.73A.75.75,0,0,0,578.79,194.17Zm8.25.17a.75.75,0,1,0,.73.77A.75.75,0,0,0,587,194.34Zm8.25.17a.76.76,0,0,0,0,1.51.76.76,0,0,0,.77-.74A.75.75,0,0,0,595.29,194.51Zm8.24.18a.75.75,0,1,0,.74.76A.75.75,0,0,0,603.53,194.69ZM559,187.27a4.86,4.86,0,0,0,0,.54s0,.09,0,.13a.65.65,0,0,0,.08-.31A.74.74,0,0,0,559,187.27Zm7.6-.23a.75.75,0,1,0,0,1.5.75.75,0,1,0,0-1.5Zm8.25.17a.75.75,0,1,0,0,1.5.74.74,0,0,0,.76-.73A.75.75,0,0,0,574.81,187.21Zm8.25.17a.75.75,0,1,0,.73.77A.75.75,0,0,0,583.06,187.38Zm8.25.17a.76.76,0,0,0,0,1.51.76.76,0,0,0,.77-.74A.75.75,0,0,0,591.31,187.55Zm8.24.17a.76.76,0,0,0-.76.74.75.75,0,1,0,1.5,0A.76.76,0,0,0,599.55,187.72ZM562,207.8a.76.76,0,0,0-.77.74.76.76,0,0,0,1.51,0A.76.76,0,0,0,562,207.8Zm8.25.17a.76.76,0,1,0,.73.77A.75.75,0,0,0,570.25,208Zm8.25.18a.75.75,0,1,0,.73.76A.74.74,0,0,0,578.5,208.15Zm8.25.17a.75.75,0,1,0,.73.76A.75.75,0,0,0,586.75,208.32Zm8.24.17a.75.75,0,1,0,.74.77A.75.75,0,0,0,595,208.49Zm8.25.17a.75.75,0,1,0,.74.77A.75.75,0,0,0,603.24,208.66Zm-37-7.65a.76.76,0,1,0,0,1.51.76.76,0,0,0,.76-.74A.75.75,0,0,0,566.27,201Zm8.25.17a.76.76,0,0,0-.77.74.75.75,0,1,0,.77-.74Zm8.24.18a.75.75,0,1,0,.74.76A.75.75,0,0,0,582.76,201.36Zm8.25.17a.75.75,0,1,0,.74.77A.75.75,0,0,0,591,201.53Zm8.25.17a.75.75,0,1,0,.74.77A.75.75,0,0,0,599.26,201.7Zm8.25.17a.76.76,0,1,0,.74.77A.76.76,0,0,0,607.51,201.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.41,170.76c-3.67,8.8-21,38.06-30,39.13-14.15,1.67-29.87-4.6-38.69-6.46-2.81-.59,3.42-25.15,8.67-23.4,6.78,2.26,20.34,4.77,24.09,4.57,2.57-.13,17-12.93,27.15-21.76C581.05,155.47,586.05,159.61,581.41,170.76Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.24,185.08l-4-2.8a16.2,16.2,0,0,1-3.32-3.33c-3.91-4.69-16.42-13.6-32.68-8.18-6.23,2.07-7.5,7.35-.64,6.34,4.83-.71,8.12-1.61,9.76-1.4,0,0-5.11,5.45-4.25,9.69a79.77,79.77,0,0,0,3.05,10.93,17.17,17.17,0,0,0,2.09-.39,9.12,9.12,0,0,0,7.3,6.4l7.24,1.56Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.48,175.07c-3.15-.5-9.86-1.46-15.62-.33-6.4,1.25-18.39,5.39-17.42,10.1.72,3.46,5.43,2.28,5.43,2.28s-4.59,2.75-3.27,5.73c1.21,2.72,4.81,1.59,4.81,1.59s-2.5,2.15-.83,4.54c2,2.88,6.91-2.1,11.47-.94C505.07,198.3,519.48,175.07,519.48,175.07Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.31,181.28a26,26,0,0,0-14.4,5.71c-.1.09-.08.21,0,.15a64.06,64.06,0,0,1,14.39-5.8A0,0,0,0,0,506.31,181.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.38,187.77c-2.62.28-9.67,2.46-14,6.56-.1.1-.08.22,0,.15a69,69,0,0,1,14-6.65S507.42,187.77,507.38,187.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.47,180.33l14,20.8s11.64-18.15,16.82-30,0-16.1-10.09-9.17S551.47,180.33,551.47,180.33Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.86,166.81a.76.76,0,0,1-.77.74.76.76,0,1,1,.77-.74Zm7.51-.59a.74.74,0,0,0-.76.73.75.75,0,1,0,.76-.73Zm-3.32-6.54c-.43.2-.87.43-1.33.68a.75.75,0,0,0,1.41-.34A.66.66,0,0,0,576.05,159.68Zm7.11-.07s0,0,0,0a.73.73,0,0,0-.28.55.75.75,0,0,0,.74.77.66.66,0,0,0,.34-.08A3.72,3.72,0,0,0,583.16,159.61Zm-28.82,20.07a.75.75,0,1,0,.73.76A.74.74,0,0,0,554.34,179.68Zm8.24.17a.75.75,0,1,0,.74.76A.75.75,0,0,0,562.58,179.85Zm8.25.17a.75.75,0,1,0,.74.77A.75.75,0,0,0,570.83,180Zm-12-7.07-1,.94a.75.75,0,0,0,1.46-.24A.74.74,0,0,0,558.88,173Zm8,.11a.75.75,0,1,0,0,1.5.75.75,0,1,0,0-1.5Zm8.25.17a.76.76,0,0,0-.77.74.74.74,0,0,0,.74.76.76.76,0,0,0,.77-.73A.76.76,0,0,0,575.1,173.23Zm-12.81,20.59a.76.76,0,1,0,.74.77A.76.76,0,0,0,562.29,193.82Zm-4-7a.76.76,0,1,0,.74.77A.76.76,0,0,0,558.31,186.86Zm8.25.18a.75.75,0,1,0,0,1.5.75.75,0,1,0,0-1.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.27,178c.47.72,1.05,1.37,1.56,2s1,1.38,1.5,2.08q1.44,2,2.89,4c2,2.72,4,5.39,5.8,8.23,0,.05,0,.11-.07.07a80.36,80.36,0,0,1-6.18-7.86q-1.47-2.06-2.88-4.15c-.47-.71-.95-1.43-1.39-2.16s-.84-1.53-1.32-2.23C556.14,178,556.24,178,556.27,178Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.59,174.77c-1.06,2.3-2.21,4.56-3.39,6.8s-2.41,4.46-3.62,6.69-2.54,4.39-3.84,6.57-2.67,4.31-4.17,6.36l-.1.14-.09-.14c-.43-.7-.86-1.4-1.28-2.11.5.66,1,1.32,1.47,2h-.19q2-3.24,3.82-6.56l3.76-6.59c1.27-2.19,2.48-4.41,3.78-6.59S579.29,176.94,580.59,174.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.44,176.86a4.55,4.55,0,0,1-.93,1.55,7.73,7.73,0,0,1-.64.64,6.48,6.48,0,0,1-.73.53A32.76,32.76,0,0,0,580.44,176.86Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91,455.38c-.42,2.33,6.24,3.71,9.2,2.48a63.74,63.74,0,0,0,7-4.64c7.36-5.26,17.6-13,17.6-13l34.8,2.1L179,406.53s-32-1.85-34.2-3l-.4-.22c-10-5.09-18.32-9-19.27-8.5C122.59,396.24,91.39,453,91,455.38Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.92,404.47l-18.3,36.21-7.82-.47s-10.24,7.75-17.61,13a64.57,64.57,0,0,1-7,4.64c-3,1.24-9.62-.15-9.2-2.48s31.63-59.14,34.18-60.55c1-.53,9.27,3.41,19.27,8.51.14.06.27.14.4.2A32.16,32.16,0,0,0,150.92,404.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3,455.84c.43-2.39,32.27-60.17,34.88-61.6,1-.56,9.67,3.59,20,8.91l.32.17-20.13,37.5-.62-.36s-22.08,16.66-25.12,17.93S89.85,458.23,90.3,455.84Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3,455.84c.43-2.39,32.27-60.17,34.88-61.6,1-.56,9.67,3.59,20,8.91l.32.17-20.13,37.5-.62-.36s-22.08,16.66-25.12,17.93S89.85,458.23,90.3,455.84Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9,456.42c5.6-9.6,27.31-48.89,32.12-58.81,0-.08,0-.11-.06,0-5.76,9.4-27.15,48.86-32.22,58.76C92.63,456.55,92.78,456.63,92.9,456.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,444.91c2.83-3.44,4.82-8.45,3.71-12.88,0-.17-.29-.11-.32,0a60.84,60.84,0,0,1-3.87,12.56A.28.28,0,0,0,123,444.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.82,446.76c2.83-3.44,4.82-8.45,3.7-12.88,0-.17-.28-.11-.31,0a61.65,61.65,0,0,1-3.87,12.56A.28.28,0,0,0,119.82,446.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.63,448.61c2.82-3.44,4.82-8.45,3.7-12.89,0-.17-.28-.1-.31,0a62.37,62.37,0,0,1-3.87,12.57A.28.28,0,0,0,116.63,448.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.62,454.5c2.91-.36,3.52-3.68,3.06-6a23.34,23.34,0,0,0-5.53-10.74.12.12,0,0,0-.19,0,.55.55,0,0,0-.81.34c-.57,3.81-1.65,7.82-1,11.69C124.47,452,125.88,454.85,128.62,454.5Zm-3.15-10.45c.23-1.88.56-3.74.73-5.63,1.07,2.1,2.23,4.14,3.09,6.34a24.57,24.57,0,0,1,1.07,3.24c.41,1.71.13,7.45-3.7,4.45C124.54,450.8,125.19,446.29,125.47,444.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.52,428.55c-3.09,2.42-5,6.09-7.2,9.27a.54.54,0,0,0,.37.79c0,.08,0,.15.12.14a23.24,23.24,0,0,0,11.37-4.1c1.93-1.4,3.74-4.24,1.86-6.49S134.32,427.14,132.52,428.55Zm3.69-.22c4.84.42,1.14,4.8-.32,5.78a26.42,26.42,0,0,1-3,1.64c-2.13,1-4.37,1.73-6.58,2.54,1.16-1.5,2.19-3.08,3.3-4.62C130.93,431.84,133.53,428.09,136.21,428.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.91,351.15A193.76,193.76,0,0,1,213,370.54s51,23.58,53,46c.73,7.93-.33,22.8-15.89,29.58-17.39,7.57-113.49,2.36-113.49,2.36l12-44.25,42.39,0s-29.91,4.76-33.16-15.17c-3-18.53,8.36-37.92,8.36-37.92Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.58,446.3c1.06-5.09,2.09-10.22,3.27-15.29s2.44-10.14,3.78-15.18c.38-1.43.77-2.84,1.15-4.26.19-.68.37-1.36.57-2a20.83,20.83,0,0,1,.62-2c0-.07.11,0,.1,0a32.52,32.52,0,0,1-.76,3.91c-.27,1.23-.52,2.47-.79,3.7-.56,2.53-1.12,5.05-1.7,7.57-1.16,5.06-2.45,10.07-3.76,15.09-.75,2.85-1.5,5.69-2.26,8.54A.11.11,0,1,1,146.58,446.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.41,404.24c3.44-.25,6.88-.36,10.32-.43s6.88,0,10.33,0,6.88.24,10.31.55a75,75,0,0,1,10.23,1.48l-2.56-.33-2.57-.25c-1.71-.14-3.42-.29-5.13-.36-3.43-.2-6.87-.34-10.3-.4s-6.87-.14-10.31-.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.66,354.78a121.21,121.21,0,0,0-4,12,77.27,77.27,0,0,0-2.45,12.4,34.71,34.71,0,0,0-.13,6.28,15.63,15.63,0,0,0,1.52,6,8.49,8.49,0,0,0,1.84,2.4,15,15,0,0,0,2.52,1.77,27.94,27.94,0,0,0,5.78,2.32,77.3,77.3,0,0,0,12.4,2.25c4.2.49,8.41.83,12.63,1.26a91.77,91.77,0,0,1,12.61,2,25.18,25.18,0,0,1,6.05,2.23,28.6,28.6,0,0,1,5.27,3.74l.95.84h-1.28l-34.27-.47L178,409.63c-5.71,0-11.43,0-17.14.12,5.71-.33,11.42-.42,17.14-.52s11.42-.12,17.14-.13h17.14l17.14.16-.33.83a27.65,27.65,0,0,0-5.08-3.57,23.71,23.71,0,0,0-5.84-2.12,99.52,99.52,0,0,0-12.47-1.92c-4.2-.45-8.42-.81-12.63-1.32a79.11,79.11,0,0,1-12.54-2.34,27.56,27.56,0,0,1-5.95-2.46,16.41,16.41,0,0,1-2.64-1.91,9.3,9.3,0,0,1-2-2.65,16.31,16.31,0,0,1-1.52-6.26,35.86,35.86,0,0,1,.22-6.39,73.83,73.83,0,0,1,2.71-12.43A111.93,111.93,0,0,1,175.66,354.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4,455.38c-.43,2.33,6.23,3.71,9.2,2.48a64,64,0,0,0,7-4.64c7.37-5.26,17.61-13,17.61-13l34.79,2.1,19.42-35.78s-32-1.85-34.2-3l-.41-.22c-10-5.09-18.31-9-19.26-8.5C125,396.24,93.83,453,93.4,455.38Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.36,404.47l-18.31,36.21-7.82-.47s-10.24,7.75-17.6,13a65.6,65.6,0,0,1-7,4.64c-3,1.24-9.63-.15-9.2-2.48s31.62-59.14,34.18-60.55c.94-.53,9.27,3.41,19.26,8.51l.41.2A32.16,32.16,0,0,0,153.36,404.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.73,455.84c.43-2.39,32.27-60.17,34.88-61.6,1-.56,9.68,3.59,20,8.91l.32.17-20.12,37.5-.63-.36s-22.08,16.66-25.11,17.93S92.29,458.23,92.73,455.84Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.33,456.42c5.61-9.6,27.31-48.89,32.13-58.81,0-.08,0-.11-.06,0-5.77,9.4-27.16,48.86-32.23,58.76C95.06,456.55,95.21,456.63,95.33,456.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.44,444.91c2.83-3.44,4.83-8.45,3.71-12.88,0-.17-.29-.11-.32,0A61.43,61.43,0,0,1,125,444.63.28.28,0,0,0,125.44,444.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.25,446.76c2.83-3.44,4.83-8.45,3.71-12.88,0-.17-.29-.11-.32,0a61.62,61.62,0,0,1-3.86,12.56A.28.28,0,0,0,122.25,446.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.06,448.61c2.83-3.44,4.82-8.45,3.71-12.89,0-.17-.29-.1-.32,0a61.71,61.71,0,0,1-3.86,12.57A.28.28,0,0,0,119.06,448.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.06,454.5c2.9-.36,3.51-3.68,3.05-6a23.34,23.34,0,0,0-5.53-10.74.11.11,0,0,0-.18,0,.55.55,0,0,0-.81.34c-.57,3.81-1.66,7.82-1,11.69C126.9,452,128.31,454.85,131.06,454.5Zm-3.16-10.45c.24-1.88.56-3.74.73-5.63,1.07,2.1,2.23,4.14,3.09,6.34A26.19,26.19,0,0,1,132.8,448c.4,1.71.12,7.45-3.71,4.45C127,450.8,127.62,446.29,127.9,444.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,428.55c-3.08,2.42-5,6.09-7.19,9.27a.53.53,0,0,0,.36.79c0,.08,0,.15.13.14a23.24,23.24,0,0,0,11.36-4.1c1.93-1.4,3.75-4.24,1.87-6.49S136.76,427.14,135,428.55Zm3.69-.22c4.85.42,1.15,4.8-.32,5.78a26.28,26.28,0,0,1-3,1.64c-2.14,1-4.37,1.73-6.59,2.54,1.17-1.5,2.19-3.08,3.3-4.62C133.36,431.84,136,428.09,138.64,428.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.34,351.15s1,12.77.92,21.17c0,0,47.16,21.8,49.21,44.21.73,7.93-.33,22.8-15.89,29.58-17.39,7.57-113.49,2.36-113.49,2.36l12-44.25,42.38,0s-29.91,4.76-33.16-15.17c-3-18.53,8.36-37.92,8.36-37.92Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,446.3c1.06-5.09,2.08-10.22,3.26-15.29s2.45-10.14,3.79-15.18c.38-1.43.76-2.84,1.15-4.26.18-.68.37-1.36.56-2s.36-1.38.62-2c0-.07.11,0,.11,0a34.6,34.6,0,0,1-.76,3.91c-.27,1.23-.53,2.47-.8,3.7q-.82,3.8-1.7,7.57c-1.16,5.06-2.45,10.07-3.76,15.09l-2.25,8.54C149.19,446.51,149,446.47,149,446.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.85,404.24c3.43-.25,6.87-.36,10.31-.43s6.89,0,10.33,0,6.89.24,10.32.55A74.89,74.89,0,0,1,220,405.87l-2.56-.33-2.56-.25c-1.71-.14-3.42-.29-5.14-.36-3.43-.2-6.86-.34-10.3-.4s-6.87-.14-10.3-.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.1,354.78a123.93,123.93,0,0,0-4,12,78.38,78.38,0,0,0-2.45,12.4,35.64,35.64,0,0,0-.13,6.28,15.64,15.64,0,0,0,1.53,6,8.45,8.45,0,0,0,1.83,2.4,15.85,15.85,0,0,0,2.52,1.77,28.16,28.16,0,0,0,5.78,2.32,77.22,77.22,0,0,0,12.41,2.25c4.19.49,8.41.83,12.63,1.26a91.87,91.87,0,0,1,12.6,2,25.1,25.1,0,0,1,6.06,2.23,28.94,28.94,0,0,1,5.27,3.74l.95.84h-1.29l-34.27-.47-17.14-.13c-5.71,0-11.42,0-17.13.12,5.7-.33,11.42-.42,17.13-.52s11.43-.12,17.14-.13h17.15l17.14.16-.34.83a27.65,27.65,0,0,0-5.08-3.57,23.64,23.64,0,0,0-5.83-2.12,99.8,99.8,0,0,0-12.47-1.92c-4.2-.45-8.42-.81-12.64-1.32a79.32,79.32,0,0,1-12.54-2.34,27.77,27.77,0,0,1-6-2.46,16.33,16.33,0,0,1-2.63-1.91,9.12,9.12,0,0,1-2-2.65,16.13,16.13,0,0,1-1.52-6.26,35.86,35.86,0,0,1,.22-6.39,72.87,72.87,0,0,1,2.71-12.43A111.93,111.93,0,0,1,178.1,354.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.66,369.61c2.39,0,9.82.42,13.37-2.57,2.87-2.43,4.13-10.7,4.63-13,0-.12.19-.08.19,0a26,26,0,0,1-1,7.59c-.58,2.1-1.36,4.44-3,5.91a12,12,0,0,1-6.48,2.37,29.7,29.7,0,0,1-7.71-.11A.13.13,0,0,1,178.66,369.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.26,372.32c16.07,7.32,31.87,16.75,43.37,30.41a28,28,0,0,1,3.87,30.44c-4,8.64-10.75,13.08-19.9,14.94a97.68,97.68,0,0,1-25.48,1.83c11.94-.06,31.68-.66,39.94-10.19a27.59,27.59,0,0,0,1.53-35.63c-11.43-14-27.27-23.81-43.33-31.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.07,299.16c-2.67.3-8.55-4.34-11-8.42-.16-.28.16-3.31.37-7,.12-2.25.2-4.75.11-7,0-.46,1.62.33,1.62.33l3,.6,9.89,2a36.55,36.55,0,0,0-1,8.83,5.33,5.33,0,0,0,.13.94s0,.09,0,.15C208.52,291.32,209.25,298.7,205.07,299.16Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.13,289.4s0,.09,0,.15a9.29,9.29,0,0,1-1.47.14c-9.67.16-11.36-12.07-11.36-12.07h3.82l9.89,2a36.55,36.55,0,0,0-1,8.83A5.33,5.33,0,0,0,208.13,289.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.53,257.33c-2,4.94-.48,19.82,2.86,23.39,4.84,5.16,13.37,6.32,17.91.36,4.41-5.78,2.13-25.14-1.65-28.44C207.07,247.78,196.43,250,193.53,257.33Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,267s-.08.06-.07.1c.17,1,.2,2.16-.66,2.62a0,0,0,1,0,0,.05C208.35,269.49,208.3,267.94,208,267Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.94,266.11c-1.62.1-1.3,3.34.2,3.25S208.3,266,206.94,266.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.29,266.33s.08,0,.09.08c.06,1,.31,2.14,1.25,2.39a0,0,0,0,1,0,.05C213.51,268.81,213.19,267.29,213.29,266.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.08,265.19c1.6-.28,2,2.94.57,3.2S212.74,265.43,214.08,265.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.52,264.76a11.1,11.1,0,0,0,1.21-.57,2.14,2.14,0,0,0,1.12-.81.69.69,0,0,0-.19-.81,1.7,1.7,0,0,0-1.73,0,2.52,2.52,0,0,0-1.33,1.22A.73.73,0,0,0,205.52,264.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.08,263.82a12.07,12.07,0,0,1-1.32-.21,2.16,2.16,0,0,1-1.3-.46.68.68,0,0,1,0-.84,1.67,1.67,0,0,1,1.65-.49,2.54,2.54,0,0,1,1.62.8A.74.74,0,0,1,215.08,263.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.38,276.51c.26.21.53.51.9.51a2.79,2.79,0,0,0,1.05-.36s.07,0,0,0a1.32,1.32,0,0,1-1.22.67,1.06,1.06,0,0,1-.87-.8A.06.06,0,0,1,207.38,276.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.13,273.41a3.47,3.47,0,0,0,2.43,1.29,4.31,4.31,0,0,0,1.24-.07.86.86,0,0,0,.23-.05l.21-.05a.25.25,0,0,0,.18-.25h0a.3.3,0,0,0,0-.1h0v-.09c0-.77-.25-1.94-.25-1.94.3.11,1.8.62,1.74.22a51.48,51.48,0,0,0-2.35-10.2c0-.11-.2-.06-.18,0,.38,3.21,1.33,6.33,1.77,9.55a6,6,0,0,0-1.66-.33c-.11,0,.41,2.25.4,2.6,0,0,0,0,0,0a4.74,4.74,0,0,1-3.64-.74C208.14,273.26,208.07,273.33,208.13,273.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.3,274.29a4,4,0,0,1-1.49,1.41,1.79,1.79,0,0,1-1.1.18c-.83-.13-.92-.86-.83-1.5a4.05,4.05,0,0,1,.26-1A5.27,5.27,0,0,0,211.3,274.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.81,275.7a1.79,1.79,0,0,1-1.1.18c-.83-.13-.92-.86-.83-1.5A1.9,1.9,0,0,1,209.81,275.7Z",
    style: {
      fill: "#ff9bbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.05,271.45c2.76-.86,3.94-10.22,3.94-10.22s.07,3.95.81,3.84,3.64-5.56,3.88-9.42a30.42,30.42,0,0,0,7.13,3.25c3.55,1,7.44.63,7.43,0-.05-1.78-1.79-6.4-4.25-8a12.58,12.58,0,0,0-12.56-1.22c-5.7,2.35-7.11,6.08-7.89,9S192,271.77,193.05,271.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.66,272.72a4.73,4.73,0,1,1,4.85-5.68h0a4.75,4.75,0,0,1-3.68,5.59A4.69,4.69,0,0,1,205.66,272.72Zm.4-8.82a3.86,3.86,0,0,0-1,.08,4.1,4.1,0,1,0,1-.08Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.48,271.9c-1.81-.09-3.36-2-3.53-4.48a5.64,5.64,0,0,1,.76-3.37,3.15,3.15,0,0,1,2.42-1.6,3.12,3.12,0,0,1,2.61,1.25,5.55,5.55,0,0,1,1.23,3.22c.19,2.61-1.24,4.84-3.18,5Zm-.07-8.82h-.24a2.5,2.5,0,0,0-1.92,1.3,5,5,0,0,0-.67,3c.16,2.25,1.57,4,3.17,3.88s2.75-2,2.59-4.29a5,5,0,0,0-1.08-2.87A2.61,2.61,0,0,0,216.41,263.08Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.39,267.6l-.44-.46c.67-.65,2.27-1.58,3.51-.42l-.43.46C211.92,266.15,210.45,267.54,210.39,267.6Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.45,270.3l-.58-.25c.11-.28,1.18-2.66,2.57-3s9.81-.11,10.18-.1l0,.63c-2.44,0-9-.15-10,.09S189.73,269.64,189.45,270.3Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.69,269.53s-3-4.95-5.26-3.9-.15,8.08,2.32,9.18a2.57,2.57,0,0,0,3.53-1.17Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.08,267.63s-.05.05,0,.07c1.73.82,2.56,2.53,3.11,4.27a1.42,1.42,0,0,0-2.1-.52s0,.11,0,.1a1.59,1.59,0,0,1,1.71.66,7.74,7.74,0,0,1,.75,1.46c.07.16.36.1.31-.09v0C195.05,271.28,193.49,268,191.08,267.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.9,249.78a21.69,21.69,0,0,0-5.84-2.29c-2.29-.49-9.66-.53-11.54.79s-2.92,8.17-3.05,9.18-.19,7.14,1.9,8.8,3.16-8.69,6.93-11.83S208.9,249.78,208.9,249.78Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.91,249.78s-7.83,1.5-11.6,4.65-4.86,13.48-6.95,11.83a4.89,4.89,0,0,1-1.57-3.39c.72-3,2.33-7.58,5.13-10.62,2.62-2.85,6.81-4.05,11.2-4.18A24.85,24.85,0,0,1,208.91,249.78Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.46,272.46c.42-2.75,3.85-9.9,7.15-13.89S209.77,252.83,211,253c2.93.41,3.85,1.39,4.34,1.16s-2.36-2.68-3.14-3.25-2.91-1.91-4.19-2-9.22.05-12.37,3.17-8,12.19-7.44,14.66c.13.59.87,1,1.05,1.87.23,1.1.35,2.37.61,3.15S190.42,272.69,190.46,272.46Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.44,256.72a13.9,13.9,0,0,1-1.79-1.56,9.58,9.58,0,0,1-1.48-1.88c0-.05-.11,0-.09,0a7.81,7.81,0,0,0,1.32,2.08,6.56,6.56,0,0,0,2,1.46C198.45,256.9,198.51,256.78,198.44,256.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.66,269.7a6.39,6.39,0,0,0-.26-.6,3.31,3.31,0,0,1-.2-.7A5.81,5.81,0,0,0,190,267a4.74,4.74,0,0,0-.57-1,1.87,1.87,0,0,1-.45-1.17c0-.05-.08-.06-.09,0a4.71,4.71,0,0,0,.75,2.22,10.39,10.39,0,0,1,.26,1.46,2.09,2.09,0,0,0,.63,1.22C190.58,269.82,190.68,269.77,190.66,269.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.86,266.79c-.23-.33-.49-.64-.7-1a8.79,8.79,0,0,1-.5-1.08c-.15-.37-.26-.74-.4-1.11s-.38-.85-.52-1.29c0-.06-.1,0-.08,0,.14.46.21,1,.34,1.41a11.66,11.66,0,0,0,.43,1.17A6.64,6.64,0,0,0,191,266a3.09,3.09,0,0,0,.83.86S191.88,266.82,191.86,266.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.09,264.18a7.79,7.79,0,0,1-1.36-1.82c-.35-.66-.66-1.34-1-2,0,0-.1,0-.09,0a9.46,9.46,0,0,0,.78,2.18,5.25,5.25,0,0,0,.63.93,5.77,5.77,0,0,0,.93.77S193.13,264.22,193.09,264.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.4,261.69a2.58,2.58,0,0,1-.67-.8c-.21-.33-.42-.67-.61-1s-.39-.65-.57-1a2.61,2.61,0,0,1-.41-1.06c0-.05-.09-.05-.09,0a2.82,2.82,0,0,0,.22,1.11,6.89,6.89,0,0,0,.54,1.13,7.93,7.93,0,0,0,.69,1,1.77,1.77,0,0,0,.84.69C194.4,261.82,194.46,261.73,194.4,261.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.46,258.48c-.23-.28-.46-.55-.68-.84s-.41-.59-.6-.89-.41-.63-.6-1c0,0-.1,0-.08,0a7.93,7.93,0,0,0,.42,1,8.32,8.32,0,0,0,.6.94,8.12,8.12,0,0,0,.69.86,2.81,2.81,0,0,0,.84.7s.11,0,.09-.08A4.86,4.86,0,0,0,195.46,258.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.69,255.33a12.7,12.7,0,0,0-.76-1.05c-.28-.34-.59-.67-.9-1a12.59,12.59,0,0,0-2-1.62s-.11,0-.07.07c1.22,1.22,2.48,2.4,3.68,3.64C200.66,255.43,200.73,255.38,200.69,255.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.56,253.11a5.69,5.69,0,0,0-.86-1,12.72,12.72,0,0,0-2.26-1.51c-.05,0-.1,0-.05.07.67.54,1.36,1.06,2,1.64a9.67,9.67,0,0,1,.92.89c.29.32.5.69.77,1,0,0,.07,0,.06,0A3.37,3.37,0,0,0,202.56,253.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,252.22a6.12,6.12,0,0,0-.79-1,7,7,0,0,0-1.92-1.35c-.05,0-.09.05,0,.08a13.65,13.65,0,0,1,1.78,1.54c.28.28.54.57.8.87s.48.65.77.91c0,0,.06,0,0,0A6.32,6.32,0,0,0,205,252.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.72,251c-.27-.26-.55-.5-.83-.75a3.81,3.81,0,0,0-.92-.62c-.05,0-.08,0,0,.08l1.56,1.52a8.93,8.93,0,0,1,1.16,1.63s.06,0,.06,0A3.58,3.58,0,0,0,206.72,251Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.83,250.71a5.55,5.55,0,0,0-1.74-1.3c-.05,0-.09.05-.05.08a7,7,0,0,1,1.57,1.4,10,10,0,0,1,1.19,1.75s.07,0,.06,0A4.68,4.68,0,0,0,208.83,250.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.44,252.17a2.86,2.86,0,0,0-.2-.44,4.74,4.74,0,0,0-.55-.8,9.76,9.76,0,0,0-1.47-1.33s-.1,0-.05.07a8,8,0,0,1,1.36,1.36,6.05,6.05,0,0,1,.53.79,3.17,3.17,0,0,1,.21.41,3.11,3.11,0,0,0,.2.41s.08,0,.08,0A1.19,1.19,0,0,0,211.44,252.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.09,252.46a7.66,7.66,0,0,0-.45-.66,7.57,7.57,0,0,0-.53-.6c-.19-.19-.4-.38-.58-.58a0,0,0,1,0-.07.06,4.61,4.61,0,0,1,.54.63c.16.21.31.42.47.62l.47.63a7.42,7.42,0,0,0,.46.64,0,0,0,0,0,.07,0A3.64,3.64,0,0,0,213.09,252.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.7,365.25c.13.17,63.4,6.74,64,6.15.9-.83-4.09-65.23-13-79.93-2.22-3.68-11-6.8-15.06-3.6-11.7,9.26-14.69,17.62-18.11,24.38-2.53,5-5.81,13.62-8.85,22.49C161.68,349.35,157.24,364.6,157.7,365.25Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.89,286.78s-6-1.24-4.8-5.26S258,279.7,258,279.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299,291.73h0l4.3,4.15,1.43,1.37-1.94.39-5.87,1.17h0l-41.22-12.1,2.07-7.08L299,291.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.27 295.88 304.7 297.25 302.75 297.64 303.27 295.88",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.99,
    y: 282.49,
    width: 8.61,
    height: 1.71,
    transform: "translate(-87.04 450.44) rotate(-73.64)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.8,
    y: 283.02,
    width: 8.61,
    height: 1.71,
    transform: "translate(-86.24 452.57) rotate(-73.65)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.71 288.25 259.5 285.58 273.98 291.43 273.63 292.39 258.71 288.25",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.9,298.12c4.7,7.53,26.26,34.69,38,34.48,14.21-.25,31.47-5,39.94-8.67C279.31,322,264,299.67,260,301.6c-6.28,3-18.9,5.73-21.41,6.22s-22-11.76-32.72-17.91C196.18,284.37,194.13,293.68,196.9,298.12Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.28,286.13c1.39,3-6.21,5.77-6.21,5.77a6,6,0,0,1,3.61,2c1.56,1.94-.79,5.24-.79,5.24a7.42,7.42,0,0,1,3.48,2.67c1.31,2-.58,5.67-.58,5.67a6.53,6.53,0,0,1,1.58,4.27c-.18,4.19-5.75,7.35-9.27,9.4s-15.42,4.55-17.64,5.25l-13.32-22.48s13.18-13.66,17.66-15.48C276.58,286.86,292.16,281.6,294.28,286.13Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,291.84c-4.41.66-8.64,2.38-12.71,4.08a.08.08,0,0,0,.06.14c4-1.74,8.62-2.44,12.7-4A.1.1,0,0,0,288,291.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.65,298.84a11.58,11.58,0,0,0-2.82,1.11c-1,.47-1.94.95-2.89,1.44-1.91,1-3.8,2-5.66,3.12-.08.05,0,.19.06.14,1.91-1,3.83-1.94,5.78-2.84,1-.46,1.95-.9,2.93-1.34a14,14,0,0,0,2.71-1.36A.15.15,0,0,0,290.65,298.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.71,307.47a8.14,8.14,0,0,0-2.49,1.14c-.86.47-1.72.94-2.59,1.4-1.73.92-3.47,1.84-5.23,2.7a.08.08,0,0,0,.06.14c1.79-.87,3.6-1.71,5.39-2.59l2.63-1.31a7.42,7.42,0,0,0,2.28-1.4S293.75,307.46,293.71,307.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.71,302.35l12.8,25.25s-24.27,8.31-34.73,5.8S206.7,312.86,199,302.16s-5.58-20.76,12.09-10,26,14.77,27.19,14.86S254.71,302.35,254.71,302.35Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.25,333.37c-.14-.09-11-.23-13.95-2.21-2.35-1.55-16.2-13.08-28.2-27.3a0,0,0,0,0-.07.06c1.69,2.44,3.54,4.78,5.46,7.06-.13-.1-.27-.19-.41-.28a41.52,41.52,0,0,1-3.47-2.43c-.08-.06-.17.07-.09.14,1.11.84,2.14,1.8,3.23,2.68.52.43,1.05.85,1.61,1.23l.67.45c.61.69,1.22,1.38,1.84,2.06,1.58,1.73,15,15,19.82,17.39,3.05,1.5,12.72,1.51,13.65,1.28C242.44,333.47,242.35,333.43,242.25,333.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.85,328.31a63.4,63.4,0,0,0-2.75-5.92q-1.39-2.88-2.85-5.74c-1.94-3.85-3.8-7.77-6-11.49a.08.08,0,0,0-.15.07c1.57,4,3.57,8,5.5,11.85q1.45,2.93,3,5.82a57.12,57.12,0,0,0,3.11,5.5A.08.08,0,0,0,261.85,328.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.23,289.05c-4.8-3.13-18.51-5.48-24.38-2.21-7.42,4.12-16.2,30.87-13.47,32.73,4.87,3.31,23.9-11.06,28.31-17.24S206.23,289.05,206.23,289.05Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,296.91c-1,.87-2,1.72-3,2.6,1.35-1.79,2.71-3.57,4-5.4.05-.06,0-.14-.1-.09a74.69,74.69,0,0,0-4.9,5.75c-1.63,2-3.27,4-5,5.86a50.53,50.53,0,0,1-5.51,5.34,53,53,0,0,1-6.67,4.55q-2,1.17-4,2.25a32,32,0,0,1-4.48,2c-.29.09-.11.2,0,.17a22.44,22.44,0,0,0,3.81-1.44c1.28-.6,2.56-1.19,3.82-1.81a47.6,47.6,0,0,0,7-4c4.31-3.08,7.61-7.13,10.71-11.36l.18-.25c.59-.53,1.16-1.08,1.71-1.64.8-.82,1.63-1.59,2.49-2.34C202.15,297,202,296.84,202,296.91Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubbles--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "206.71 219.05 206.71 243.88 210.19 243.88 210.19 249.9 216.21 243.88 249.26 243.88 249.26 219.05 206.71 219.05",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.71,219.05c.09,6.2.23,18.64.3,24.83l-.3-.3c.09,0,3.86,0,3.8,0v.33l0,6-.63-.26,6-6.06c.15-.15.11-.13.3-.13l33-.06-.49.49.07-24.83.42.43c-10.6-.06-31.95-.29-42.55-.43Zm0,0c10.82-.14,32.15-.36,43-.43v.43l.06,24.83v.49h-.49l-33-.06.31-.13-6.71,6.62c0-.3.07-6.41.06-6.92l.32.33-3.48,0h-.31c.07-6.34.21-18.79.31-25.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,231.47a2,2,0,1,0,2-2A2,2,0,0,0,236,231.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,231.47a2,2,0,1,0,2-2A2,2,0,0,0,226,231.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.91,231.47a2,2,0,1,0,2-2A2,2,0,0,0,215.91,231.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "592.16 99.35 592.16 124.17 595.65 124.17 595.65 130.19 601.67 124.17 634.72 124.17 634.72 99.35 592.16 99.35",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.16,99.35c.1,6.19.23,18.63.3,24.82l-.3-.3c.1,0,3.86,0,3.81,0v.33l0,6-.63-.26,6-6.06c.14-.15.11-.12.3-.12l33.05-.07-.49.49.06-24.82.43.42c-10.61-.06-32-.29-42.56-.42Zm0,0c10.83-.14,32.16-.37,43-.43v.43l.06,24.82v.49h-.49l-33.05-.06.3-.13c-.2.21-6.77,6.69-6.7,6.62,0-.3.07-6.41.05-6.92l.33.33-3.49,0h-.3c.07-6.34.21-18.79.3-25.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.49,111.76a2,2,0,1,0,2-2A2,2,0,0,0,621.49,111.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.42,111.76a2,2,0,1,0,2-2A2,2,0,0,0,611.42,111.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.36,111.76a2,2,0,1,0,2-2A2,2,0,0,0,601.36,111.76Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventsCuate);
export default __webpack_public_path__ + "static/media/Events-cuate.5e839e8c1d8e7537faab8389822b5e1a.svg";
export { ForwardRef as ReactComponent };